import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  FormLabel,
  Row,
  Table,
  FormControl,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import noImage from "../images/clicktoAdd.png";
import { ConfigManager } from "../config/ConfigManager.js";
import { NEW_ENTRY, DOCUMENT_CHANGED } from "../ds/App_Constants.js";
import { BaseBean, NodeData, RestReportBean } from "../ds/client_ds.js";
import {
  AddressBean,
  FabricStyleSearchCriteria,
  InTransitPackingListPrintRequest,
  PageListBean,
  PurchaseOrderBean,
  PurchaseOrderInTransitBean,
  PurchaseOrderInTransitElectronicInputBean,
  PurchaseOrderInTransitLineBean,
  PurchaseOrderInTransitLineSearchCriteria,
  PurchaseOrderInTransitRollLineBean,
  PurchaseOrderInTransitRollLineSearchCriteria,
  PurchaseOrderInTransitSearchCriteria,
  PurchaseOrderSearchCriteria,
  ReasonBean,
  RestEntityUnLockRequest,
  RestFabricStyleListRequest,
  RestPurchaseOrderInTransitBeanRequest,
  RestPurchaseOrderInTransitExcelImportRequest,
  RestPurchaseOrderInTransitListRequest,
  RestPurchaseOrderInTransitReasonRequest,
  RestPurchaseOrderInTransitRollLineRequest,
  RestPurchaseOrderListRequest,
  RestReadRequest,
  RestVendorListRequest,
  VendorBean,
  VendorSearchCriteria,
  PurchaseOrderInTransitImageBean,
  PurchaseOrderInTransitDocumentBean,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ReasonCaptureComponent,
  ShortCutMenuPopup,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toFormattedDate_v1,
} from "../gui_components/Util.js";
import { CameraIcon, UploadDocIcon } from "../gui_components/Icons.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { PurchaseOrderInTransitLookupHandler } from "../lookup/PurchaseOrderInTransitLookupHandler.js";
import { PurchaseOrderLookupHandler } from "../lookup/PurchaseOrderLookupHandler.js";
import { PopupPurchaseOrderModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { PurchaseOrderInTransitService } from "../services/PurchaseOrderInTransitService.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import { ReportService } from "../services/ReportService.js";
import { VendorService } from "../services/VendorService.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import CustomTable from "../gui_components/CustomTable.js";

class PurchaseOrderInTransitList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.unapproveReasonDialogRef = React.createRef();
    this.cancelReasonDialogRef = React.createRef();
    this.lineCancelReasonDialogRef = React.createRef();
    this.rollLineCancelReasonDialogRef = React.createRef();

    this.state = {
      pageTitle: "PurchaseOrder InTransit Maintenance",
      purchaseOrderInTransitListData: [],
      pageList: new PageListBean(),
      criteria: new PurchaseOrderInTransitSearchCriteria(),
      purchaseOrderInTransitData: new PurchaseOrderInTransitBean(),
      purchaseOrderInTransitLineData: new PurchaseOrderInTransitLineBean(),
      purchaseOrderInTransitRollLineData:
        new PurchaseOrderInTransitRollLineBean(),
      purchaseOrderData: new PurchaseOrderBean(),
      currentVendor: new VendorBean(),
      purchaseOrderInTransitElectronicInputBean:
        new PurchaseOrderInTransitElectronicInputBean(),
      purchaseOrdersList: new Array(),
      currentPageNumber: 0,
      totalCount: 0,
      error_list: [],
      nodeList: [],
      vendor_List: new Array(),
      fabricStyle_List: new Array(),
      fOBCities: new Array(),
      shipmentTerms: new Array(),
      wareHouses: new Array(),
      incoTerms: new Array(),
      paymentTerms: new Array(),
      vendorTerms: new Array(),
      transportTypes: new Array(),
      countries: new Array(),
      uoms: new Array(),
      shipVias: new Array(),
      isLoading: true,
      isDisableFields: false,
      isShowNodes: false,
      isShowNewButton: true,
      isShowBackButton: false,
      isShowSaveButton: false,
      isShowClearErrorButton: false,
      isShowPDFReportButton: false,
      isShowUnApproveButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isPurchaseOrderInTransitListFormOpen: true,
      isPurchaseOrderInTransitEntryFormOpen: false,
      isPurchaseOrderInTransitHistoryFormOpen: false,
      selectedNodeKey: "inTransitHeaderView",
      selectedDocument: "",
      isResetModule: false,
      moduleForPopup: [],
      isShowPopup: false,
      simplePopupContent: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      purchaseOrderInTransitLookupHandler: null,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      isResetModule: false,
      moduleOrderStatus: "",
      cancelReason: [],
      unApproveReason: [],
      disabledFormFields: false,
      reasonData: new ReasonBean(),
      disabled: false,
      isResetView: true,
      isFocus: false,
      poInTransitRollLinesList: new Array(),
      isMaintenanceMode: true,
      isDisabledFields: false,
      isShowProgressBarPopup: false,
      filter: "",
      progressLoadingText: "",
      order: "asc",
      sortField: "",
      isShowPopupAlertlvl1: false,
      isShowPopupAlertlvl5: false,
      isShowInTransitButton: false,
      isShowRollLinePopup: false,
      isShowPurchaseOrderModule: false,
      fabricStyles: [],
      purchaseOrderBean: new PurchaseOrderBean(),
      isShowAutoCompletePurchaseOrderList: false,
      purchaseOrderPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLocationList: false,
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteFobCityList: false,
      FobCityPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteShipmentTermList: false,
      shipmentTermPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteShipViaList: false,
      shipViaPageListForAutoCompleteList: new Array(),
      isShowButtons: true,
      isModifyPosible: false,
      is3PL: false,
      isShowCancelReasonPopup: false,
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowUnApproveReasonPopup: false,
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
      isShowLineCancelReasonPopup: false,
      isShowRollLineCancelReasonPopup: false,
      isReseted: false,
      isViewMode: false,
      isTexco: true,

      isImageFormOpened: false,
      imgUrl: "",
      images: [],
      preview_Url: [],

      documents: [],
      preview_Docs: [],
      isDocumentFormOpened: false,
      tempIndex: null,
      isServiceLineDisablesFields: false,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  moduleCaption = "Purchase Order InTransit Maintenance";
  fetchAttributesFromLocalStorage = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    let fOBCities = attribute_cache.fOBCities;
    let fOBCities_temp = [];
    if (fOBCities != null || fOBCities != undefined) {
      fOBCities.map((attr) => {
        fOBCities_temp.push(attr);
        this.state.fOBCities = ModuleUtils.isActiveAttribute(fOBCities_temp);
      });
    }
    let shipmentTerms = attribute_cache.shipmentTerms;
    let shipmentTerms_temp = [];
    if (shipmentTerms != null || shipmentTerms != undefined) {
      shipmentTerms.map((attr) => {
        shipmentTerms_temp.push(attr);
        this.state.shipmentTerms =
          ModuleUtils.isActiveAttribute(shipmentTerms_temp);
      });
    }
    let warehouses = attribute_cache.warehouses;
    let warehouses_temp = [];
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        warehouses_temp.push(attr);
        this.state.wareHouses = ModuleUtils.isActiveAttribute(warehouses_temp);
      });
    }
    let incoTerms = attribute_cache.incoTerms;
    let incoTerms_temp = [];
    if (incoTerms != null || incoTerms != undefined) {
      incoTerms.map((attr) => {
        incoTerms_temp.push(attr);
        this.state.incoTerms = ModuleUtils.isActiveAttribute(incoTerms_temp);
      });
    }
    let paymentTerms = attribute_cache.paymentTerms;
    let paymentTerms_temp = [];
    if (paymentTerms != null || paymentTerms != undefined) {
      paymentTerms.map((attr) => {
        paymentTerms_temp.push(attr);
        this.state.paymentTerms =
          ModuleUtils.isActiveAttribute(paymentTerms_temp);
      });
    }
    let transportTypes = attribute_cache.transportTypes;
    let transportTypes_temp = [];
    if (transportTypes != null || transportTypes != undefined) {
      transportTypes.map((attr) => {
        transportTypes_temp.push(attr);
        this.state.transportTypes =
          ModuleUtils.isActiveAttribute(transportTypes_temp);
      });
    }
    let countries = attribute_cache.countries;
    let countries_temp = [];
    if (countries != null || countries != undefined) {
      countries.map((attr) => {
        countries_temp.push(attr);
        this.state.countries = ModuleUtils.isActiveAttribute(countries_temp);
      });
    }
    let uoms = attribute_cache.uoms;
    let uoms_temp = [];
    if (uoms != null || uoms != undefined) {
      uoms.map((attr) => {
        uoms_temp.push(attr);
        this.state.uoms = ModuleUtils.isActiveAttribute(uoms_temp);
      });
    }
    let vendorTerms = attribute_cache.vendorTerms;
    let vendorTerms_temp = [];
    if (vendorTerms != null || vendorTerms != undefined) {
      vendorTerms.map((attr) => {
        vendorTerms_temp.push(attr);
        this.state.vendorTerms =
          ModuleUtils.isActiveAttribute(vendorTerms_temp);
      });
    }
    let shipVias = attribute_cache.vendorShipVias;
    let shipVias_temp = [];
    if (shipVias != null || shipVias != undefined) {
      shipVias.map((attr) => {
        shipVias_temp.push(attr);
        this.state.shipVias = ModuleUtils.isActiveAttribute(shipVias_temp);
      });
    }
    let cancelReason = attribute_cache.purchaseOrderCancelReasons;
    let cancelReason_temp = [];
    if (cancelReason != null || cancelReason != undefined) {
      cancelReason.map((attr) => {
        cancelReason_temp.push(attr);
        this.state.cancelReason =
          ModuleUtils.isActiveAttribute(cancelReason_temp);
      });
    }
    let unApproveReason = attribute_cache.purchaseOrderUnApprovalReasons;
    let unApproveReason_temp = [];
    if (unApproveReason != null || unApproveReason != undefined) {
      unApproveReason.map((attr) => {
        unApproveReason_temp.push(attr);
        this.state.unApproveReason =
          ModuleUtils.isActiveAttribute(unApproveReason_temp);
      });
    }
    if (ConfigManager.isTexcoFabricKey()) {
      this.setState({
        isTexco: true,
      });
    }
  };
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.setState({
        is3PL: true,
      });
    }
    this.fetchAttributesFromLocalStorage();
    this.state.criteria = new PurchaseOrderInTransitSearchCriteria();
    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;
    ModuleUtils.getPurchaseOrderInTransitStatusList();
    ModuleUtils.getPurchaseOrderInTransitLineStatusList();
    this.getVendorList();
    this.getFabricStyleList();
    this.getPurchaseOrdersList();
    this.initLookupHandlers();
    // this.loadPage();
    //set readOnly components using view Modes && disable toolbars
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      // this.unlockPurchaseOrderInTransit(this.props.code);
      this.editPurchaseOrderInTransit(this.props.code);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        disabledFormFields: true,
        isViewMode: true,
      });
    } else {
      // this.addNewEntry();
      this.loadPage();
    }
  }
  initLookupHandlers = () => {
    let purchaseOrderInTransitLookupHandler =
      new PurchaseOrderInTransitLookupHandler(
        this.companyCode,
        "PurchaseOrder InTransit",
      );
    this.setState({
      purchaseOrderInTransitLookupHandler: purchaseOrderInTransitLookupHandler,
    });
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  clearError = () => {
    this.clearErrors();
  };
  clearErrors = () => {
    let errList = [];
    this.setState({ error_list: errList });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handlePopupResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowPopupAlertlvl1: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowPopupAlertlvl1: true,
      });
    }
  };
  loadPage = (pageNumber) => {
    const currentPageList = this.state.pageList;
    const pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (currentPageList != null)
      pageInput.totalCount = currentPageList.totalCount;

    this.setState({ pageList: pageInput }, () => {
      this.loadPurchaseOrderInTransitPage();
    });
  };
  onCriteriaChange = (e) => {
    let criteria = this.state.criteria;
    if (e.target.name == "criteriakey") {
      criteria["purchaseOrderInTransitNumberContains"] = e.target.value;
      criteria["purchaseOrderNumberStartsWith"] = e.target.value;
    }
    this.setState({ criteria: criteria });
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  loadPurchaseOrderInTransitPage = () => {
    let requestInput = new RestPurchaseOrderInTransitListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
      isResetView: false,
      isMaintenanceMode: false,
    });
    if (
      SecurityAccessManager.PurchaseOrderInTransitMaintenance_IsAccessible()
    ) {
      PurchaseOrderInTransitService.getPurchaseOrderInTransitPageList(
        requestInput,
        this.loadPurchaseOrderInTransitResponse,
        this.errorCallback,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  // loadPurchaseOrderInTransitResponse = (response) => {
  //   if (response.data != null && response.data.inTransitPageListBean != null) {
  //     let pageList = this.state.pageList;
  //     let purchaseOrderInTransitListData =
  //       response.data.inTransitPageListBean.purchaseOrderinTransits;
  //     if (
  //       purchaseOrderInTransitListData != null &&
  //       !isEmptyArray(purchaseOrderInTransitListData)
  //     ) {
  //       pageList.totalCount = response.data.inTransitPageListBean.totalCount;
  //       pageList.currentPage = response.data.inTransitPageListBean.currentPage;
  //       this.setState({
  //         isLoading: false,
  //         purchaseOrderInTransitListData: purchaseOrderInTransitListData,
  //         pageList: pageList,
  //       });
  //     }
  //   }
  //   this.setState({
  //     isLoading: false,
  //     loadingText: "",
  //   });
  // };
  loadPurchaseOrderInTransitResponse = (response) => {
    if (response.data != null && response.data.inTransitPageListBean != null) {
      const { purchaseOrderinTransits, totalCount, currentPage } =
        response.data.inTransitPageListBean;

      if (!isEmptyArray(purchaseOrderinTransits)) {
        // ✅ Fix Bug 1 - spread instead of mutating state object
        this.setState((prevState) => ({
          isLoading: false,
          loadingText: "",
          purchaseOrderInTransitListData: purchaseOrderinTransits,
          pageList: {
            ...prevState.pageList,
            totalCount: totalCount,
            currentPage: currentPage,
          },
        }));
      } else {
        // ✅ Fix Bug 2 - explicitly clear list when no data found
        this.setState((prevState) => ({
          isLoading: false,
          loadingText: "",
          purchaseOrderInTransitListData: [],
          pageList: {
            ...prevState.pageList,
            totalCount: 0,
            currentPage: 1,
          },
          alertMessage: ["No Records Found"],
          alertType: "danger",
          isShowAlert: true,
        }));
      }
    } else {
      // ✅ Fix Bug 3 - handle null response — also clear list
      this.setState({
        isLoading: false,
        loadingText: "",
        purchaseOrderInTransitListData: [],
        alertMessage: ["No Records Found"],
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPurchaseOrderInTransitError = (error) => {
    ShowError("Error :" + error);
  };
  getVendorList = () => {
    let criteria = new VendorSearchCriteria();
    criteria.companyCode = this.companyCode;
    let requestInput = new RestVendorListRequest();
    requestInput.pageInput = new PageListBean();
    requestInput.searchCriteria = criteria;
    VendorService.getVendorPageList(
      requestInput,
      this.getVendorListResponse,
      this.getVendorListError,
    );
  };

  getVendorListResponse = (response) => {
    if (response.data != null && response.data.vendorPageList != null) {
      let vendor_List = response.data.vendorPageList.vendors;
      if (isEmptyArray(vendor_List)) {
        vendor_List = new Array();
      }
      this.setState({ vendor_List: vendor_List });
    }
  };
  getVendorListError = (error) => {
    ShowError("Error : ", error);
  };
  getFabricStyleList = () => {
    let criteria = new FabricStyleSearchCriteria();
    criteria.companyCode = this.companyCode;
    let requestInput = new RestFabricStyleListRequest();
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    requestInput.pageInput = new PageListBean();
    requestInput.searchCriteria = criteria;

    FabricStyleService.getFabricStylePageList(
      requestInput,
      this.getFabricStyleResponse,
      this.getFabricStyleError,
    );
  };

  getFabricStyleResponse = (response) => {
    if (response.data != null && response.data.fabricStylePageList != null) {
      let fabricStyle_List = response.data.fabricStylePageList.fabricStyles;
      if (fabricStyle_List == null) {
        fabricStyle_List = new Array();
      }
      this.setState({ fabricStyle_List: fabricStyle_List });
    }
  };
  getFabricStyleError = (error) => {
    ShowError("Error : ", error);
  };

  getPurchaseOrdersList = () => {
    this.loadPurchaseOrderList();
  };
  loadPurchaseOrderList = () => {
    let criteria = new PurchaseOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    let orderStatusList = new Array();
    orderStatusList.push("A");
    orderStatusList.push("I");
    criteria.orderStatusList = orderStatusList;
    let requestInput = new RestPurchaseOrderListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (
      SecurityAccessManager.PurchaseOrderInTransitMaintenance_IsAccessible()
    ) {
      PurchaseOrderService.getPurchaseOrderPageList(
        requestInput,
        this.loadPurchaseOrderResponse,
        this.loadPurchaseOrderError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPurchaseOrderResponse = (response) => {
    if (
      !isEmptyArray(response.data) &&
      !isEmptyArray(response.data.purchaseOrderPageList)
    ) {
      let purchaseOrdersList =
        response.data.purchaseOrderPageList.purchaseOrders;
      if (isEmptyArray(purchaseOrdersList)) {
        purchaseOrdersList = new Array();
      }
      this.setState({ purchaseOrdersList: purchaseOrdersList });
    }
  };
  loadPurchaseOrderError = (error) => {
    ShowError("Error : ", error);
  };
  readPurchaseOrder = (purchaseOrderCode) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading Fields ..",
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = purchaseOrderCode;
    readrestInput.isLoadChildren = true;
    PurchaseOrderService.initPurchaseOrderModule(
      readrestInput,
      this.readPurchaseOrderResponse,
      this.readPurchaseOrderError,
    );
  };
  readPurchaseOrderResponse = (response) => {
    if (
      !isEmptyArray(response.data) &&
      !isEmpty(response.data.purchaseOrderResponse)
    ) {
      let poBean = response.data.purchaseOrderResponse.purchaseOrder;
      if (!isEmptyArray(poBean)) {
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          purchaseOrderData: poBean,
        });

        this.toUpdatePurchaseOrderData(poBean);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readPurchaseOrderError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : ", error);
  };
  getPurchaseOrderLineMaxLineNumber = (purchaseOrderInTransitData) => {
    let maxLineNumber = 1;
    let poLineData = purchaseOrderInTransitData.lines;
    if (poLineData.length > 0)
      poLineData.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  };
  toUpdatePurchaseOrderData = (purchaseOrderData) => {
    let purchaseOrderInTransitData = {
      ...this.state.purchaseOrderInTransitData,
    };
    if (!isEmpty(purchaseOrderData)) {
      purchaseOrderInTransitData.factoryCode = purchaseOrderData.factoryCode;
      purchaseOrderInTransitData.inTransitDate = new Date();
      purchaseOrderInTransitData.createdDate = new Date();
      purchaseOrderInTransitData.etaDate = new Date();
      purchaseOrderInTransitData.purchaseOrderNumber = purchaseOrderData.code;
      purchaseOrderInTransitData.vendorCode = purchaseOrderData.vendorCode;
      purchaseOrderInTransitData.vendorName = purchaseOrderData.vendorName;
      purchaseOrderInTransitData.factoryCode = purchaseOrderData.factoryCode;
      purchaseOrderInTransitData.fOBCity = purchaseOrderData.fOBCity;
      purchaseOrderInTransitData.shipViaCode = purchaseOrderData.shipViaCode;
      purchaseOrderInTransitData.shipmentTermsCode =
        purchaseOrderData.shipmentTermsCode;
      purchaseOrderInTransitData.locationCode = purchaseOrderData.locationCode;
      purchaseOrderInTransitData.customerCode = purchaseOrderData.customerCode;
      purchaseOrderInTransitData.customerReferenceNumber =
        purchaseOrderData.customerReferenceNumber;
      purchaseOrderInTransitData.containerNumber =
        purchaseOrderData.containerNumber;
      purchaseOrderInTransitData.vendorInvoiceNumber =
        purchaseOrderData.vendorInvoiceNumber;
      purchaseOrderInTransitData.etaDate = purchaseOrderData.etaDate;
      purchaseOrderInTransitData.etdDate = purchaseOrderData.etdDate;
      var lineNumber = this.getPurchaseOrderLineMaxLineNumber(
        purchaseOrderInTransitData,
      );
      let inTransitLines = new Array();
      if (purchaseOrderData.lines) {
        purchaseOrderData.lines.map((line) => {
          if (line.lineStatus == "O" && line.inTransitQuantity == 0) {
            let inTransitLine = new PurchaseOrderInTransitLineBean();
            inTransitLine.companyCode = line.companyCode;
            inTransitLine.lineStatus = "O";
            inTransitLine.purchaseOrderNumber = line.purchaseOrderNumber;
            inTransitLine.lineNumber = lineNumber;
            inTransitLine.purchaseOrderLineNumber = line.lineNumber;
            inTransitLine.fabricStyleCode = line.fabricStyleCode;
            inTransitLine.fabricStyleName = line.fabricStyleName;
            inTransitLine.widthCode = line.widthCode;
            inTransitLine.colorCode = line.colorCode;
            inTransitLine.skuNumber = line.skuNumber;
            inTransitLine.upcCode = line.upcCode;
            inTransitLine.uomCode = line.uomCode;
            inTransitLine.inventoryUomCode = line.inventoryUomCode;
            inTransitLine.uomConversionRate = line.uomConversionRate;
            inTransitLine.locationCode = line.locationCode;
            inTransitLine.vendorStyleCode = line.vendorStyleCode;
            inTransitLine.vendorStyleColorCode = line.vendorStyleColorCode;
            inTransitLine.purchaseOrderQuantity = line.orderQuantity;
            inTransitLine.openOrderQuantity = line.orderQuantity;
            inTransitLine.receivedQuantity = line.receivedQuantity;
            inTransitLine.receivedQuantityToDate = 0;
            inTransitLine.badQualityReceivedQuantity = 0;
            inTransitLine.goodQualityReceivedQuantity = 0;
            inTransitLine.inTransitQuantity = line.inTransitQuantity;
            inTransitLine.openInTransistQuantity = line.inTransitQuantity;
            inTransitLine.adjustedTransitQuantity = 0;
            ++lineNumber;
            inTransitLines.push(inTransitLine);
          }
        });
      }

      purchaseOrderInTransitData.lines = inTransitLines;
    }
    this.setState({ purchaseOrderInTransitData: purchaseOrderInTransitData });
  };
  getEmptyView() {
    return <div></div>;
  }
  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "inTransitHeaderView") {
      this.setPurchaseInTransitHeaderView();
    } else if (selectedNode == "historyView") {
      this.setPurchaseInTransitHistoryView();
    } else if (selectedNode == "imageView") {
      this.setPurchaseInTransitImageView();
    } else if (selectedNode == "documentView") {
      this.setPurchaseInTransitDocumentView();
    }
  };
  getNodeList = () => {
    let nodeList = {};
    let purchaseOrderInTransitData = this.state.purchaseOrderInTransitData;
    let headerObject = this.getEmptyView();
    let historyDetailObject = this.getEmptyView();
    let headerNode = new NodeData(
      "inTransitHeaderView",
      "Header",
      headerObject,
    );
    let historyDetailNode = new NodeData(
      "historyView",
      "History",
      historyDetailObject,
    );
    let imageNode = new NodeData("imageView", "Image", headerObject);

    let documentNode = new NodeData("documentView", "document", headerObject);

    nodeList["inTransitHeaderView"] = headerNode;
    if (purchaseOrderInTransitData.isFetched) {
      nodeList["historyView"] = historyDetailNode;
      nodeList["imageView"] = imageNode;
      nodeList["documentView"] = documentNode;
    }
    this.setState({ nodeList: nodeList });
  };
  setPurchaseInTransitHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isPurchaseOrderInTransitListFormOpen: false,
      isPurchaseOrderInTransitEntryFormOpen: true,
      isPurchaseOrderInTransitHistoryFormOpen: false,
      isImageFormOpened: false,
      isDocumentFormOpened: false,
    });
  };
  setPurchaseInTransitHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isPurchaseOrderInTransitListFormOpen: false,
      isPurchaseOrderInTransitEntryFormOpen: false,
      isPurchaseOrderInTransitHistoryFormOpen: true,
      isImageFormOpened: false,
      isDocumentFormOpened: false,
    });
  };
  setPurchaseInTransitImageView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isPurchaseOrderInTransitListFormOpen: false,
      isPurchaseOrderInTransitEntryFormOpen: false,
      isPurchaseOrderInTransitHistoryFormOpen: false,
      isImageFormOpened: true,
      isDocumentFormOpened: false,
    });
  };
  setPurchaseInTransitDocumentView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isPurchaseOrderInTransitListFormOpen: false,
      isPurchaseOrderInTransitEntryFormOpen: false,
      isPurchaseOrderInTransitHistoryFormOpen: false,
      isImageFormOpened: false,
      isDocumentFormOpened: true,
    });
  };
  closeAllNodeViews = () => {
    this.setState({
      isPurchaseOrderInTransitListFormOpen: false,
      isPurchaseOrderInTransitEntryFormOpen: false,
      isPurchaseOrderInTransitHistoryFormOpen: false,
      isImageFormOpened: false,
      isDocumentFormOpened: false,
    });
  };
  save = () => {
    this.savePurchaseOrderInTransit();
  };
  validatePOIntransit = (poIntransitBean) => {
    let isValidPoIntransitBean = false;
    let err_list = [];
    let errorMessage = "";
    if (poIntransitBean == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyArray(poIntransitBean.lines)) {
        err_list.push("PO Intransit Lines is Required");
      }
      if (isEmptyString(poIntransitBean.purchaseOrderNumber)) {
        let errMsg = "PO Number is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(poIntransitBean.vendorCode)) {
        let errMsg = "Vendor Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(poIntransitBean.vendorName)) {
        let errMsg = "Vendor Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidPoIntransitBean = false;
      this.setState({ errorList: err_list });

      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
        isShowPopupAlert: false,
        isShowPopupAlertlvl1: false,
        isShowPopupAlertlvl5: false,
      });
    } else {
      isValidPoIntransitBean = true;
      this.setState({
        isShowAlert: false,
        isShowPopupAlert: false,
        isShowPopupAlertlvl1: false,
        isShowPopupAlertlvl5: false,
      });
    }
    return isValidPoIntransitBean;
  };
  savePurchaseOrderInTransit = () => {
    let poInTransitBean = this.state.purchaseOrderInTransitData;
    let isValidLine = false;
    isValidLine = this.validatePOIntransit(poInTransitBean);
    if (isValidLine) {
      if (poInTransitBean.isFetched) {
        if (
          SecurityAccessManager.PurchaseOrderInTransitMaintenanceUpdate_IsAccessible()
        ) {
          PurchaseOrderInTransitService.updatePurchaseOrderInTransit(
            poInTransitBean,
            this.savePurchaseOrderInTransitResponse,
            this.savePurchaseOrderInTransitError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (
          SecurityAccessManager.PurchaseOrderInTransitMaintenanceCreate_IsAccessible()
        ) {
          PurchaseOrderInTransitService.createPurchaseOrderInTransit(
            poInTransitBean,
            this.savePurchaseOrderInTransitResponse,
            this.savePurchaseOrderInTransitError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  savePurchaseOrderInTransitResponse = (response) => {
    this.handleresponse(response.data);
    if (response.data != null && response.data.purchaseOrderinTransit != null) {
      let PurchaseOrderInTransitBean = response.data.purchaseOrderinTransit;
      let pageTitle = this.moduleCaption + " - EDIT";
      this.setState(
        {
          purchaseOrderInTransitData: PurchaseOrderInTransitBean,
          pageTitle: pageTitle,
          selectedNodeKey: "inTransitHeaderView",
        },
        () => {
          this.uploadImagesToServer();
          this.uploadMultiDocsToServer();
          if (!this.isLocked) {
            this.editPurchaseOrderInTransit(PurchaseOrderInTransitBean.code);
          } else {
            this.code = PurchaseOrderInTransitBean.code;
            this.unlockPurchaseOrderInTransit(PurchaseOrderInTransitBean.code);
          }
        },
      );
    }
  };
  savePurchaseOrderInTransitError = (error) => {
    ShowError("Error : " + error);
  };
  uploadImagesToServer = () => {
    const purchaseOrderInTransitData = {
      ...this.state.purchaseOrderInTransitData,
    };

    const images = this.state.images;
    if (
      !isEmptyArray(purchaseOrderInTransitData.purchaseOrderInTransitImages)
    ) {
      purchaseOrderInTransitData.purchaseOrderInTransitImages.map((img) => {
        if (img.isDeleted != true && img.isFetched != true) {
          images.map((imgData) => {
            if (img.imageOritinalname == imgData.name) {
              this.toServer(imgData, img.imageName);
            }
          });
        } else if (img.isFetched == true && img.isApplied == true) {
          images.map((imgData) => {
            if (img.imageOritinalname == imgData.name) {
              this.toServer(imgData, img.imageName);
            }
          });
        }
      });
    }
  };
  uploadMultiDocsToServer = () => {
    const purchaseOrderInTransitData = {
      ...this.state.purchaseOrderInTransitData,
    };
    const documents = this.state.documents;
    if (
      !isEmptyArray(purchaseOrderInTransitData.purchaseOrderInTransitDocuments)
    ) {
      purchaseOrderInTransitData.purchaseOrderInTransitDocuments.map((doc) => {
        if (doc.isDeleted != true && doc.isFetched != true) {
          documents.map((docData) => {
            if (doc.documentOriginalName == docData.name) {
              this.docToServer(docData, doc.documentName);
            }
          });
        }
      });
    }
  };
  docToServer = (file, fileName) => {
    let document = new File([file], `${fileName}`, { type: file.type });
    const formData = new FormData();
    formData.append("file", document);
    PurchaseOrderInTransitService.purchaseOrderInTransitDocUpload(
      formData,
      this.documentUploadResponse,
      this.errorCallBack,
    );
  };
  documentUploadResponse = (response) => {};
  toServer = (file, fileName) => {
    let image = new File([file], `${fileName}`, { type: file.type });
    const formData = new FormData();
    formData.append("file", image);

    PurchaseOrderInTransitService.purchaseOrderInTransitImageUpload(
      formData,
      this.imageUploadResponse,
      this.errorCallBack,
    );
    // this.setState({
    //   aftUpload: true,
    // });
  };
  imageUploadResponse = (response) => {};
  approvePurchaseOrderInTransit = (e) => {
    if (e.detail == 1) {
      this.setState({
        isLoading: true,
        loadingText: "Approving PO InTransit",
      });
      let poInTransitBean = this.state.purchaseOrderInTransitData;
      if (
        SecurityAccessManager.PurchaseOrderInTransitMaintenanceApprove_IsAccessible()
      ) {
        PurchaseOrderInTransitService.approvePurchaseOrderInTransit(
          poInTransitBean,
          this.approvePurchaseOrderInTransitResponse,
          this.approvePurchaseOrderInTransitError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  approvePurchaseOrderInTransitResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleresponse(response.data);
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.purchaseOrderinTransit)
    ) {
      const purchaseOrderInTransitBean = response.data.purchaseOrderinTransit;
      if (purchaseOrderInTransitBean != null) {
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          purchaseOrderInTransitData: purchaseOrderInTransitBean,
          pageTitle: pageTitle,
          disabledFormFields: true,
        });
        // this.unlockPurchaseOrderInTransit(purchaseOrderInTransitBean.code);
        // this.editPurchaseOrderInTransit(purchaseOrderInTransitBean.code);
        if (this.isLocked) {
          this.code = purchaseOrderInTransitBean.code;
          this.unlockPurchaseOrderInTransit(purchaseOrderInTransitBean.code);
        }
      }
    }
  };
  approvePurchaseOrderInTransitError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error :" + error);
  };
  saveUnApprovePurchaseOrderInTransit = () => {
    this.setState({
      isLoading: true,
      loadingText: "UnApprove PO InTransit",
    });
    let poInTransitBean = this.state.purchaseOrderInTransitData;
    let purchaseInTransitRequest =
      new RestPurchaseOrderInTransitReasonRequest();
    purchaseInTransitRequest.purchaseOrderInTransitBean = poInTransitBean;
    purchaseInTransitRequest.reason = this.state.reasonData;
    if (
      SecurityAccessManager.PurchaseOrderInTransitMaintenanceUnApprove_IsAccessible()
    ) {
      PurchaseOrderInTransitService.unApprovePurchaseOrderInTransit(
        purchaseInTransitRequest,
        this.unApprovePurchaseOrderInTransitResponse,
        this.unApprovePurchaseOrderInTransitError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unApprovePurchaseOrderInTransitResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });

    this.handleresponse(response.data);
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.purchaseOrderinTransit)
    ) {
      const purchaseOrderInTransitBean = response.data.purchaseOrderinTransit;
      if (purchaseOrderInTransitBean != null) {
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          purchaseOrderInTransitData: purchaseOrderInTransitBean,
          pageTitle: pageTitle,
          disabledFormFields: false,
        });
        // this.unlockPurchaseOrderInTransit(purchaseOrderInTransitBean.code);
        // this.editPurchaseOrderInTransit(purchaseOrderInTransitBean.code);
        if (this.isLocked) {
          this.code = purchaseOrderInTransitBean.code;
          this.unlockPurchaseOrderInTransit(purchaseOrderInTransitBean.code);
        }
      }
    }
  };
  unApprovePurchaseOrderInTransitError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };

  onUnApproveReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteUnApproveReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteUnApproveReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteUnApproveReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteUnApproveReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteUnApproveReasonList: showAutoCompleteList,
        reasonData: reason,
        unApproveReasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readUnApproveReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.unApproveReason;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteUnApproveReasonList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteUnApproveReasonList;
          this.setState({
            showAutoCompleteUnApproveReasonList: showAutoCompleteList,
          });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readUnApproveReasonBySearchString(searchString) {
    let reasonData = this.state.unApproveReason;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      unApproveReasonPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  unApproveReasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.unApproveReason;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        unApproveReasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteUnApproveReasonList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteUnApproveReasonList: showAutoCompleteList,
    });
  };

  unApprovePurchaseOrderInTransit = (e) => {
    if (e.detail == 1) this.openReasonCapture(2);
  };

  onUnApproveReasonContinue = () => {
    this.saveUnApprovePurchaseOrderInTransit();
    this.closeReasonModelCallBack();
  };
  saveCancelPurchaseOrderInTransit = () => {
    this.setState({
      isLoading: true,
      loadingText: "Cancelling PO InTransit",
    });
    let poInTransitBean = this.state.purchaseOrderInTransitData;
    let purchaseInTransitRequest =
      new RestPurchaseOrderInTransitReasonRequest();
    purchaseInTransitRequest.purchaseOrderInTransitBean = poInTransitBean;
    purchaseInTransitRequest.reason = this.state.reasonData;
    if (
      SecurityAccessManager.PurchaseOrderInTransitMaintenanceCancel_IsAccessible()
    ) {
      if (
        poInTransitBean.inTransitStatus ===
        LogicConstants.PURCHASEORDER_INTRANSIT_UNAPPROVE_STATUS
      ) {
        PurchaseOrderInTransitService.cancelAndUnLockPurchaseOrderInTransit(
          purchaseInTransitRequest,
          this.cancelPurchaseOrderInTransitResponse,
          this.cancelPurchaseOrderInTransitError,
        );
      } else {
        PurchaseOrderInTransitService.cancelAndUnLockPurchaseOrderInTransitAfterApproval(
          purchaseInTransitRequest,
          this.cancelPurchaseOrderInTransitResponse,
          this.cancelPurchaseOrderInTransitError,
        );
      }
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  cancelPurchaseOrderInTransitResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });

    if (response.data != null) {
      if (response.data.lockResponse != null) {
        this.showErrorMessage(response.data.lockResponse);
      }
      this.handleresponse(response.data.mainOperationResponse);
      const purchaseOrderInTransitBean =
        response.data.mainOperationResponse.purchaseOrderinTransit;
      if (purchaseOrderInTransitBean != null) {
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          purchaseOrderInTransitData: purchaseOrderInTransitBean,
          pageTitle: pageTitle,
          disabledFormFields: true,
        });

        this.editPurchaseOrderInTransit(purchaseOrderInTransitBean.code);
      }
    }
  };
  cancelPurchaseOrderInTransitError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error :" + error);
  };
  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };
  onReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.cancelReason;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.cancelReason;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.cancelReason;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  closeReasonModelCallBack = () => {
    this.setState({
      isShowCancelReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowUnApproveReasonPopup: false,
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
      isShowLineCancelReasonPopup: false,
      isShowRollLineCancelReasonPopup: false,
    });
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowCancelReasonPopup: true,
      });
    } else if (type === 2) {
      this.setState({
        isShowUnApproveReasonPopup: true,
      });
    } else if (type === 3) {
      this.setState({
        isShowLineCancelReasonPopup: true,
      });
    } else if (type === 4) {
      this.setState({
        isShowRollLineCancelReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
    });
  };
  onCancelReasonContinue = () => {
    this.saveCancelPurchaseOrderInTransit();
    this.closeReasonModelCallBack();
  };
  cancelPurchaseOrderInTransit = (e) => {
    if (e.detail == 1) this.openReasonCapture(1);
  };
  back = () => {
    this.closeEntryForm();
    this.loadPage(1);
  };
  onChange = (e) => {
    let tempPurchaseOrderInTransitData = this.state.purchaseOrderInTransitData;
    tempPurchaseOrderInTransitData[e.target.name] = e.target.value;
    this.setState({
      purchaseOrderInTransitData: tempPurchaseOrderInTransitData,
    });
  };
  purchaseOrderOnChange = (e) => {
    let purchaseOrderNumber = e.target.value;
    this.state.isShowAutoCompletePurchaseOrderList = true;
    let tempPurchaseInTransitData = this.state.purchaseOrderInTransitData;
    let showAutoCompleteList = this.state.isShowAutoCompletePurchaseOrderList;
    if (isEmpty(purchaseOrderNumber)) {
      this.state.isShowAutoCompletePurchaseOrderList = false;
      let showAutoCompleteList = this.state.isShowAutoCompletePurchaseOrderList;
      let purchaseOrderInTransitData = this.state.purchaseOrderInTransitData;
      purchaseOrderInTransitData.purchaseOrderNumber = "";
      purchaseOrderInTransitData.lines = new Array();
      purchaseOrderInTransitData.locationCode = "";
      purchaseOrderInTransitData.vendorCode = "";
      purchaseOrderInTransitData.shipViaCode = "";
      purchaseOrderInTransitData.fOBCity = "";
      purchaseOrderInTransitData.billOfLading = "";
      purchaseOrderInTransitData.factoryCode = "";
      purchaseOrderInTransitData.shipmentTermsCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        purchaseOrderInTransitData: purchaseOrderInTransitData,
        purchaseOrderPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "purchaseOrderNumber" &&
      showAutoCompleteList === true &&
      purchaseOrderNumber !== ""
    ) {
      this.readPurchaseOrderBySearchString(e.target.value);
    }
    tempPurchaseInTransitData[e.target.name] = e.target.value;
    this.setState({ purchaseOrderInTransitData: tempPurchaseInTransitData });
  };

  readPurchaseOrderBySearchString(searchString) {
    let searchCriteria = new PurchaseOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.purchaseOrderNumberStartsWith = searchString;
    searchCriteria.purchaseOrderNumberContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestPurchaseOrderListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    PurchaseOrderService.getPurchaseOrderPageList(
      cust_requestInput,
      this.readPurchaseOrderBySearchStringResponse,
      this.readPurchaseOrderBySearchStringError,
    );
  }
  readPurchaseOrderBySearchStringResponse = (response) => {
    let purchaseorderData = response.data.purchaseOrderPageList.purchaseOrders;
    let simpleAutoCompleteList = new Array();
    if (purchaseorderData.length > 0 && purchaseorderData != null) {
      purchaseorderData.map((po) => {
        let simpleItemBean = {
          code: po.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      purchaseOrderPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readPurchaseOrderBySearchStringError = (error) => {
    ShowError("Error : " + error);
  };
  purchaseOrderEnterKeyEventHandler = (e) => {
    let poCode = e.target.value;
    this.readPurchaseOrder(poCode);
    this.setState({
      purchaseOrderPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompletePurchaseOrderList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompletePurchaseOrderList: showAutoCompleteList,
    });
  };
  closeEntryForm = () => {
    this.closeAllNodeViews();
    this.setState({
      isPurchaseOrderInTransitListFormOpen: true,
      isPurchaseOrderInTransitEntryFormOpen: false,
      isCollapsible_open: false,
      isShowSaveButton: false,
      isShowNewButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: false,
      isShowPDFReportButton: false,
      isShowUnApproveButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isShowNodes: false,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isResetView: false,
      isMaintenanceMode: false,
      isShowInTransitButton: false,
      disabledFormFields: false,
      isViewMode: false,
      isSpecialViewMode: false,
      isShowAlert: false,
    });
  };
  openEntryForm = () => {
    this.closeAllNodeViews();
    this.getNodeList();
    this.setState({
      isPurchaseOrderInTransitListFormOpen: false,
      isPurchaseOrderInTransitEntryFormOpen: true,
      isCollapsible_open: false,
      isShowSaveButton: true,
      isShowNewButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowPDFReportButton: false,
      isShowUnApproveButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isShowNodes: true,
      isShowModuleSearchContainer: true,
      isResetView: false,
      isShowInTransitButton: false,
      isShowAutoCompletePurchaseOrderList: false,
      purchaseOrderPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLocationList: false,
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteFobCityList: false,
      FobCityPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteShipmentTermList: false,
      shipmentTermPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteShipViaList: false,
      shipViaPageListForAutoCompleteList: new Array(),
      isShowButtons: true,
      disabledFormFields: false,
      isModifyPosible: false,
      selectedNodeKey: "inTransitHeaderView",
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isCustomerListFormOpen: false,
        disabled: false,
        isDisableNodeFields: false,
        //  isDisabledFields: false,
        disabledFormFields: false,
      });
    } else {
      this.setState({
        isDisabledFields: true,
        disabledFormFields: true,
        disabled: true,
        isShowButtons: false,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    let purchaseOrderInTransitData = this.state.purchaseOrderInTransitData;
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let inTransitStatus = ModuleUtils.getPurchaseOrderInTransitStatusCaption(
      this.state.purchaseOrderInTransitData.inTransitStatus,
    );
    if (inTransitStatus !== undefined && inTransitStatus !== null) {
      moduleOrderStatus = inTransitStatus;
    }
    this.setState({ moduleOrderStatus: moduleOrderStatus });
    if (purchaseOrderInTransitData.isFetched) {
      if (
        purchaseOrderInTransitData.inTransitStatus ==
        LogicConstants.PURCHASEORDER_INTRANSIT_APPROVE_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: true,
          isShowCancelButton: true,
          isShowApproveButton: false,
          isShowSaveButton: true,
          isShowInTransitButton: true,
          isDisabledFields: true,
          disabledFormFields: true,
          isShowButtons: true,
          isModifyPosible: true,
        });
      }
      if (
        purchaseOrderInTransitData.inTransitStatus ==
        LogicConstants.PURCHASE_ORDER_INTRANSIT_PARTIALLY_RECEIVED_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: true,
          isShowApproveButton: false,
          isShowSaveButton: true,
          isShowInTransitButton: true,
          isDisabledFields: true,
          disabledFormFields: true,
          isShowButtons: false,
          isModifyPosible: true,
        });
      }
      if (
        purchaseOrderInTransitData.inTransitStatus ==
        LogicConstants.PURCHASEORDER_INTRANSIT_UNAPPROVE_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: true,
          isShowApproveButton: true,
          isShowSaveButton: true,
          isShowInTransitButton: true,
          isDisabledFields: true,
          disabledFormFields: false,
          isShowButtons: true,
          isModifyPosible: false,
        });
      }
      if (
        purchaseOrderInTransitData.inTransitStatus ==
        LogicConstants.PURCHASEORDER_INTRANSIT_CANCEL_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: false,
          isShowApproveButton: false,
          isShowSaveButton: false,
          isShowInTransitButton: false,
          isDisabledFields: true,
          disabledFormFields: true,
          isShowButtons: false,
          isModifyPosible: false,
        });
      }
      if (
        purchaseOrderInTransitData.inTransitStatus ==
        LogicConstants.PURCHASEORDER_INTRANSIT_RECEIVED_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: false,
          isShowApproveButton: false,
          isShowSaveButton: false,
          isShowInTransitButton: false,
          isDisabledFields: true,
          disabledFormFields: true,
          isShowButtons: false,
          isModifyPosible: false,
        });
      }
    }
    if (!purchaseOrderInTransitData.isFetched) {
      this.setState({
        isShowUnApproveButton: false,
        isShowInTransitButton: false,
        isShowApproveButton: false,
        isShowAutoCompletePurchaseOrderList: false,
        purchaseOrderPageListForAutoCompleteList: new Array(),
        isShowAutoCompleteLocationList: false,
        locationPageListForAutoCompleteList: new Array(),
        isShowAutoCompleteFobCityList: false,
        FobCityPageListForAutoCompleteList: new Array(),
        isShowAutoCompleteShipmentTermList: false,
        shipmentTermPageListForAutoCompleteList: new Array(),
        isShowAutoCompleteShipViaList: false,
        shipViaPageListForAutoCompleteList: new Array(),
        isDisabledFields: false,
        disabledFormFields: false,
        isShowButtons: true,
        isModifyPosible: false,
      });
    }

    // if (this.state.isModifyPosible) {
    //   this.setState({
    //     isShowSaveButton: true,
    //   });
    //   this.isModifyPosible();
    // }
    if (this.isModifyPosible == true) {
      this.setState({
        isShowSaveButton: true,
      });
    }
    if (this.state.isViewMode) {
      let pageTitle = this.moduleCaption + " - VIEW";
      this.setState({
        disabled: true,
        pageTitle: pageTitle,
        isDisabledFields: true,
        disabledFormFields: true,
        isShowButtons: false,
        isModifyPosible: false,
      });
    }
  };
  isModifyPosible = () => {
    let isModify = false;

    let intransitData = this.state.purchaseOrderInTransitData;
    if (
      intransitData.inTransitStatus ==
        LogicConstants.PURCHASEORDER_INTRANSIT_APPROVE_STATUS ||
      intransitData.inTransitStatus ==
        LogicConstants.PURCHASE_ORDER_INTRANSIT_PARTIALLY_RECEIVED_STATUS
    ) {
      isModify = true;
    }
    return isModify;
  };
  editPurchaseOrderInTransit = (intransitCode) => {
    let readrequest = new RestReadRequest();
    readrequest.companyCode = this.companyCode;
    readrequest.code = intransitCode;
    // readrequest.isLoadChildren = true;
    // let isLockRequired = NEW_ENTRY === intransitCode ? false : true;
    // readrequest.isLockRequired = isLockRequired;

    let isLockRequired = false;
    if (this.props.isSpecialViewMode) {
      isLockRequired = false;
    } else {
      isLockRequired = NEW_ENTRY === intransitCode ? false : true;
    }
    readrequest.isLockRequired = isLockRequired;
    this.setState({ isLoading: true });
    if (
      SecurityAccessManager.PurchaseOrderInTransitMaintenanceView_IsAccessible()
    ) {
      PurchaseOrderInTransitService.initPurchaseOrderInTransitModule(
        readrequest,
        this.readPurchaseOrderInTransitResponse,
        this.readPurchaseOrderInTransitError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readPurchaseOrderInTransitResponse = (response) => {
    let errMsg = "";
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.purchaseOrderInTransitResponse != null) {
      if (response.data.purchaseOrderInTransitResponse.errors != null) {
        response.data.purchaseOrderInTransitResponse.errors.map((err) => {
          errMsg = err.messageDescription;
        });
      }
    }
    if (response.data.purchaseOrderInTransitResponse != null) {
      if (
        errMsg !=
        "Purchase Order InTransit [" + this.state.moduleKeyCode + "] Not read!"
      ) {
        this.showErrorMessage(response.data.purchaseOrderInTransitResponse);
      }
    }
    if (response.data.dependenciesResponse != null) {
      if (response.data.dependenciesResponse.dependenciesBean != null) {
        let fabricStyles =
          response.data.dependenciesResponse.dependenciesBean.fabricStyles;
        let purchaseOrderBean =
          response.data.dependenciesResponse.dependenciesBean.purchaseOrder;
        this.setState({
          fabricStyles: fabricStyles,
          purchaseOrderBean: purchaseOrderBean,
        });
      }
    }

    if (response.data.purchaseOrderInTransitResponse != null) {
      if (
        response.data.purchaseOrderInTransitResponse.purchaseOrderinTransit !=
        null
      ) {
        let poInTransitBean =
          response.data.purchaseOrderInTransitResponse.purchaseOrderinTransit;
        if (poInTransitBean != null) {
          let pageTitle = this.moduleCaption + " - EDIT";
          let moduleKeyCode = poInTransitBean.code;

          // if (this.state.isTexco) {
          if (!isEmptyArray(poInTransitBean.purchaseOrderInTransitImages)) {
            const imagesList = poInTransitBean.purchaseOrderInTransitImages;
            let url = this.getImageURL();
            let url_list = [];
            imagesList.map((urlIndex) => {
              url_list.push(url + urlIndex.imageName);
            });
            this.setState({
              // imgData: imagesList,
              preview_Url: url_list,
              images: imagesList,
            });
          } else {
            this.setState({
              imgUrl: "",
              images: [],
              preview_Url: [],
            });
          }
          if (!isEmptyArray(poInTransitBean.purchaseOrderInTransitDocuments)) {
            const preview_Docs =
              poInTransitBean.purchaseOrderInTransitDocuments;
            let url = this.getDocURL();
            let urlDoc_list = [];
            preview_Docs.map((urlIndex) => {
              urlDoc_list.push(url + urlIndex.documentName);
            });
            this.setState({
              // imgData: imagesList,
              documents: preview_Docs,
              preview_Docs: urlDoc_list,
            });
          } else {
            this.setState({
              preview_Docs: [],
              documents: [],
            });
          }
          // }

          this.state.purchaseOrderInTransitData = poInTransitBean;
          this.setState({
            purchaseOrderInTransitData: poInTransitBean,
            pageTitle: pageTitle,
            isLoading: false,
            moduleKeyCode: moduleKeyCode,
            isFocus: true,
          });
          this.isLocked = true;
          this.getNodeList();
          this.openEntryForm();
        }
      } else {
        this.addNewEntry();
      }
    }
    this.setState({ isLoading: false });
  };
  getImageURL = () => {
    const { appData } = this.context;
    return appData.serviceURL + "/" + "purchaseorderintransitimages?file=";
  };
  getDocURL = () => {
    const { appData } = this.context;
    return appData.serviceURL + "/" + "purchaseorderintransitdocs?file=";
    // return appData.serviceURL + "/" + process.env.REACT_APP_ITEM_DOC_PATH;
  };
  readPurchaseOrderInTransitError = (error) => {
    ShowError("Error :" + error);
  };
  editPurchaseOrderInTransitLine = (val, rowData) => {
    let inTransitData = this.state.purchaseOrderInTransitData;
    let inTransitLineData = { ...rowData };
    let poInTransitRollLinesList = [];
    inTransitLineData.inTransitRollLines.map((ln) => {
      poInTransitRollLinesList.push(ln);
    });
    inTransitLineData.purchaseOrderInTransitNumber = inTransitData.code;
    inTransitLineData.totalRolls = poInTransitRollLinesList.length;
    this.setState({
      purchaseOrderInTransitLineData: inTransitLineData,
      poInTransitRollLinesList: poInTransitRollLinesList,
    });
  };
  toRollLineStatus = (rollLineStatus) => {
    let openQty = 0;
    let poInTransitRollLinesList = this.state.poInTransitRollLinesList;
    poInTransitRollLinesList.map((ln) => {
      openQty = ln.inTransitQuantity - ln.adjustedTransitQuantity;
      if (openQty == 0) {
        return (rollLineStatus = "Cancelled");
      } else if (ln.receivedQuantity > 0) {
        return (rollLineStatus = "Received");
      } else {
        return (rollLineStatus = "Open");
      }
    });
    return rollLineStatus;
  };
  onPurchaseOrderInTransitLineChange = (e) => {
    let purchaseOrderInTransitLineData =
      this.state.purchaseOrderInTransitLineData;
    purchaseOrderInTransitLineData[e.target.name] = e.target.value;
    this.setState({
      purchaseOrderInTransitLineData: purchaseOrderInTransitLineData,
    });
  };
  // addOrUpdatePurchaseOrderInTransitLine = () => {
  //   let purchaseOrderInTransitData = this.state.purchaseOrderInTransitData;
  //   let lines = [];
  //   lines = purchaseOrderInTransitData.lines;
  //   let purchaseOrderInTransitLineData =
  //     this.state.purchaseOrderInTransitLineData;
  //   purchaseOrderInTransitLineData.inTransitRollLines =
  //     this.state.poInTransitRollLinesList;
  //   let rollLines = purchaseOrderInTransitLineData.inTransitRollLines;
  //   let isLineFound = false;
  //   if (!isEmptyArray(lines)) {
  //     lines.map((line, i) => {
  //       if (line.lineNumber == purchaseOrderInTransitLineData.lineNumber) {
  //         lines[i] = purchaseOrderInTransitLineData;
  //         isLineFound = true;
  //       }
  //     });
  //   }
  //   purchaseOrderInTransitData.lines = lines;
  //   this.setState({
  //     purchaseOrderInTransitData: purchaseOrderInTransitData,
  //     isShowPopup: false,
  //   });
  //   this.closePoIntransitLinePopup();
  // };

  addOrUpdatePurchaseOrderInTransitLine = () => {
    const poInTransitRollLinesList = this.state.poInTransitRollLinesList;

    // ✅ Always recalculate from current roll lines — never trust a stale cached value
    let inTransitQuantity = 0;
    poInTransitRollLinesList.forEach((roll) => {
      inTransitQuantity += parseFloat(roll.inTransitQuantity) || 0;
    });

    const updatedLineData = {
      ...this.state.purchaseOrderInTransitLineData,
      inTransitRollLines: [...poInTransitRollLinesList],
      inTransitQuantity: inTransitQuantity.toFixed(2),
      totalRolls: poInTransitRollLinesList.length,
    };

    // ✅ Update the line inside the parent's lines array
    const lines = (this.state.purchaseOrderInTransitData.lines || []).map(
      (line) =>
        line.lineNumber === updatedLineData.lineNumber ? updatedLineData : line,
    );

    const purchaseOrderInTransitData = {
      ...this.state.purchaseOrderInTransitData,
      lines,
    };

    // ✅ One atomic setState — no partial/racing updates
    this.setState({
      purchaseOrderInTransitData,
      purchaseOrderInTransitLineData: updatedLineData,
      poInTransitRollLinesList: [],
      isShowPopup: false,
    });
  };

  closePoIntransitLinePopup = () => {
    this.setState({ poInTransitRollLinesList: new Array() });
  };
  editPurchaseOrderInTransitRollLine = (val, rowData) => {
    let rollLineData = { ...rowData };
    this.setState({ purchaseOrderInTransitRollLineData: rollLineData });
    if (rowData.isFetched) {
      this.setState({
        isDisableRollLine: true,
        disableFormFields: true,
      });
    }
  };

  onPurchaseOrderInTransitRollLineChange = (e) => {
    let purchaseOrderInTransitRollLineData =
      this.state.purchaseOrderInTransitRollLineData;
    purchaseOrderInTransitRollLineData[e.target.name] = e.target.value;
    this.setState({
      purchaseOrderInTransitRollLineData: purchaseOrderInTransitRollLineData,
    });
  };
  validatePOIntransitRollLines = (rollLine) => {
    let isValidPoIntransitBean = false;
    let err_list = [];
    let errorMessage = "";
    if (rollLine == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (
        isEmptyString(rollLine.inTransitQuantity) ||
        !(rollLine.inTransitQuantity > 0)
      ) {
        let errMsg = "Invalid IntransitQty";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(rollLine.vendorLotNumber)) {
        let errMsg = "Invalid VendorLot";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidPoIntransitBean = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: false,
        isShowPopupAlert: false,
        isShowPopupAlertlvl1: false,
        isShowPopupAlertlvl5: true,
      });
    } else {
      isValidPoIntransitBean = true;
      this.setState({
        isShowAlert: false,
        isShowPopupAlert: false,
        isShowPopupAlertlvl1: false,
        isShowPopupAlertlvl5: false,
      });
    }
    return isValidPoIntransitBean;
  };

  addOrUpdatePurchaseOrderInTransitRollLine = (e) => {
    let purchaseOrderInTransitLineData =
      this.state.purchaseOrderInTransitLineData;
    let purchaseOrderInTransitRollLineData =
      this.state.purchaseOrderInTransitRollLineData;
    let poInTransitRollLinesList = [...this.state.poInTransitRollLinesList];
    let inTransitQuantity = 0;
    let isValidLine = false;
    isValidLine = this.validatePOIntransitRollLines(
      purchaseOrderInTransitRollLineData,
    );
    if (isValidLine) {
      let rollLineFound = false;
      if (!isEmptyArray(poInTransitRollLinesList)) {
        poInTransitRollLinesList.map((line, i) => {
          if (
            line.inTransitRollLineNumber ==
            purchaseOrderInTransitRollLineData.inTransitRollLineNumber
          ) {
            poInTransitRollLinesList[i] = {
              ...purchaseOrderInTransitRollLineData,
            };
            rollLineFound = true;
          }
        });
      }
      if (!rollLineFound) {
        poInTransitRollLinesList.push(purchaseOrderInTransitRollLineData);
      }

      if (!isEmptyArray(poInTransitRollLinesList)) {
        poInTransitRollLinesList.map((roll) => {
          inTransitQuantity =
            inTransitQuantity + parseFloat(roll.inTransitQuantity);
        });
      }
      purchaseOrderInTransitLineData.inTransitQuantity =
        inTransitQuantity.toFixed(2);
      purchaseOrderInTransitLineData.totalRolls =
        poInTransitRollLinesList.length;

      this.setState({
        poInTransitRollLinesList: poInTransitRollLinesList,
        purchaseOrderInTransitLineData: purchaseOrderInTransitLineData,
      });
      this.closeRollLinePopup();
    }
  };

  addNewRollLine = (e) => {
    let purchaseOrderInTransitLineData =
      this.state.purchaseOrderInTransitLineData;
    let poInTransitRollLinesList = this.state.poInTransitRollLinesList;
    let rollLineNumber = 0;
    poInTransitRollLinesList.map((roll) => {
      if (roll.inTransitRollLineNumber > 0)
        rollLineNumber = roll.inTransitRollLineNumber;
    });
    rollLineNumber++;
    let rollLineData = new PurchaseOrderInTransitRollLineBean();
    rollLineData.companyCode = purchaseOrderInTransitLineData.companyCode;
    rollLineData.purchaseOrderInTransitNumber =
      purchaseOrderInTransitLineData.purchaseOrderInTransitNumber;
    rollLineData.inTransitRollLineNumber = rollLineNumber;
    rollLineData.rollNumber = rollLineNumber;
    rollLineData.inTransitLineNumber =
      purchaseOrderInTransitLineData.lineNumber;
    rollLineData.locationCode = purchaseOrderInTransitLineData.locationCode;
    rollLineData.fabricStyleCode =
      purchaseOrderInTransitLineData.fabricStyleCode;
    rollLineData.fabricStyleName =
      purchaseOrderInTransitLineData.fabricStyleName;
    rollLineData.widthCode = purchaseOrderInTransitLineData.widthCode;
    rollLineData.uomCode = purchaseOrderInTransitLineData.uomCode;
    rollLineData.colorCode = purchaseOrderInTransitLineData.colorCode;
    rollLineData.skuNumber = purchaseOrderInTransitLineData.skuNumber;
    rollLineData.inventoryUomCode =
      purchaseOrderInTransitLineData.inventoryUomCode;
    rollLineData.uomConversionRate =
      purchaseOrderInTransitLineData.uomConversionRate;
    rollLineData.inTransitQuantity = 0;
    rollLineData.receivedQuantity = 0;
    rollLineData.purchaseOrderNumber =
      purchaseOrderInTransitLineData.purchaseOrderNumber;
    this.setState({ purchaseOrderInTransitRollLineData: rollLineData });
  };
  addNewEntry = () => {
    let purchaseOrderInTransitData = new PurchaseOrderInTransitBean();
    let isShowSaveButton = true;
    this.setState({
      purchaseOrderInTransitData: purchaseOrderInTransitData,
      isShowSaveButton: isShowSaveButton,
    });
    this.setNewPurchaseOrderInTransitDefaultData(purchaseOrderInTransitData);
    this.openEntryForm();
  };
  setNewPurchaseOrderInTransitDefaultData = (purchaseOrderInTransitData) => {
    purchaseOrderInTransitData.companyCode = this.companyCode;
    purchaseOrderInTransitData.inTransitStatus =
      LogicConstants.PURCHASEORDER_RECEIPT_UNAPPROVE_STATUS;
    purchaseOrderInTransitData.currencyCode = "USD";
    let pageTitle = this.moduleCaption + " - NEW";
    if (
      this.state.moduleKeyCode != NEW_ENTRY &&
      !isEmptyString(this.state.moduleKeyCode)
    ) {
      purchaseOrderInTransitData.code = this.state.moduleKeyCode;
    } else {
      purchaseOrderInTransitData.code = NEW_ENTRY;
    }
    if (this.state.moduleKeyCode == NEW_ENTRY) {
      this.isLocked = false;
    } else {
      this.isLocked = true;
    }
    purchaseOrderInTransitData.inTransitDate = toFormattedDate_v1(new Date());
    purchaseOrderInTransitData.createdDate = new Date();
    purchaseOrderInTransitData.etaDate = toFormattedDate_v1(new Date());
    this.setState({
      purchaseOrderInTransitData: purchaseOrderInTransitData,
      pageTitle: pageTitle,
      isLoading: false,
      disableFormFields: false,
    });
    this.state.purchaseOrderInTransitData = purchaseOrderInTransitData;
  };
  getPurchaseOrderInTransitLinesDatasFromExcel = () => {
    this.setState({
      isLoading: true,
      loadingText: "Loading Excel Data",
    });
    let purchaseOrderInTransitLineData =
      this.state.purchaseOrderInTransitLineData;
    let purchaseOrderInTransitData = this.state.purchaseOrderInTransitData;
    let selectedDocument = this.state.selectedDocument;
    let readrestInput = new RestPurchaseOrderInTransitExcelImportRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.purchaseOrderNumber =
      purchaseOrderInTransitData.purchaseOrderNumber;
    readrestInput.excelFileName = selectedDocument;
    if (
      SecurityAccessManager.PurchaseOrderInTransitMaintenance_IsAccessible()
    ) {
      PurchaseOrderInTransitService.getPurchaseOrderInTransitInputFromExcel(
        readrestInput,
        this.readPurchaseOrderIntransitDataFromExcelResponse,
        this.readPurchaseOrderIntransitDataFromExcelError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readPurchaseOrderIntransitDataFromExcelResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    if (!isEmpty(response.data) && !isEmpty(response.data.einput)) {
      let inputBean = response.data.einput;
      this.setState({
        purchaseOrderInTransitElectronicInputBean: inputBean,
      });
      this.toGenerateRollLinesFromElectronicInputBean();
    }
  };
  readPurchaseOrderIntransitDataFromExcelError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error:" + error);
  };
  toGenerateRollLinesFromElectronicInputBean = () => {
    let purchaseOrderInTransitElectronicInputBean =
      this.state.purchaseOrderInTransitElectronicInputBean;
    let purchaseOrderInTransitLineData =
      this.state.purchaseOrderInTransitLineData;
    let poInTransitRollLinesList = this.state.poInTransitRollLinesList;
    if (!purchaseOrderInTransitLineData) {
      return;
    }
    if (!purchaseOrderInTransitLineData.fabricStyleCode) {
      return;
    }
    if (!poInTransitRollLinesList) {
      poInTransitRollLinesList = new Array();
    }
    let rollLineNumber = 0;
    let inTransitQuantity = 0;
    let rollLines = purchaseOrderInTransitElectronicInputBean.rollLines;
    if (rollLines != null && !isEmptyArray(rollLines)) {
      for (let list of rollLines) {
        if (
          list.fabricStyleCode ===
            purchaseOrderInTransitLineData.fabricStyleCode &&
          list.colorCode === purchaseOrderInTransitLineData.colorCode
        ) {
          rollLineNumber++;
          let rollLineData = new PurchaseOrderInTransitRollLineBean();
          rollLineData.companyCode = purchaseOrderInTransitLineData.companyCode;
          rollLineData.purchaseOrderNumber =
            purchaseOrderInTransitLineData.purchaseOrderNumber;
          rollLineData.purchaseOrderInTransitNumber =
            purchaseOrderInTransitLineData.purchaseOrderInTransitNumber;
          rollLineData.inTransitRollLineNumber = rollLineNumber;
          rollLineData.inTransitLineNumber =
            purchaseOrderInTransitLineData.lineNumber;
          rollLineData.locationCode =
            purchaseOrderInTransitLineData.locationCode;
          rollLineData.fabricStyleCode =
            purchaseOrderInTransitLineData.fabricStyleCode;
          rollLineData.fabricStyleName =
            purchaseOrderInTransitLineData.fabricStyleName;
          rollLineData.widthCode = purchaseOrderInTransitLineData.widthCode;
          rollLineData.uomCode = purchaseOrderInTransitLineData.uomCode;
          rollLineData.colorCode = purchaseOrderInTransitLineData.colorCode;
          rollLineData.skuNumber = purchaseOrderInTransitLineData.skuNumber;
          rollLineData.inventoryUomCode =
            purchaseOrderInTransitLineData.inventoryUomCode;
          rollLineData.uomConversionRate =
            purchaseOrderInTransitLineData.uomConversionRate;
          rollLineData.inTransitQuantity = list.quantity;
          rollLineData.rollNumber = list.rollNumber;
          rollLineData.vendorLotNumber = list.lotNumber;
          rollLineData.boxNumber = list.boxNumber;
          rollLineData.aisleInfoText = list.aisleInfoText;
          rollLineData.infoText = list.infoText;
          inTransitQuantity = inTransitQuantity + parseFloat(list.quantity);
          poInTransitRollLinesList.push(rollLineData);
        } else {
          let errMsg =
            "Load Roll from Excel File, No Matching inTransitRoll Data for this FabricStyle / Color";
          let errList = [];
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
    purchaseOrderInTransitLineData.totalRolls = rollLines.length;
    purchaseOrderInTransitLineData.inTransitQuantity = inTransitQuantity;
    this.setState({
      purchaseOrderInTransitLineData: purchaseOrderInTransitLineData,
      poInTransitRollLinesList: poInTransitRollLinesList,
    });
  };
  uploadExcelFile = (e) => {
    let file = e.target.files[0];
    let fileName = file.name;
    let fileData = new File([file], `${fileName}`, { type: file.type });
    let formData = new FormData();
    formData.append("file", fileData);
    this.setState({ selectedDocument: fileName });
    if (
      SecurityAccessManager.PurchaseOrderInTransitMaintenance_IsAccessible()
    ) {
      PurchaseOrderInTransitService.uploadExcelInput(
        formData,
        this.uploadRollLineExcelResponse,
        this.uploadRollLineExcelError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  uploadRollLineExcelResponse = (response) => {
    if (response.data != null) {
      if (response.data.success == true) {
        this.getPurchaseOrderInTransitLinesDatasFromExcel();
      }
    }
  };
  uploadRollLineExcelError = (error) => {};
  unlockPurchaseOrderInTransit = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (
      SecurityAccessManager.PurchaseOrderInTransitMaintenance_IsAccessible()
    ) {
      PurchaseOrderInTransitService.unLockPurchaseOrderInTransit(
        request,
        this.unlockPurchaseOrderInTransitResponse,
        this.unlockPurchaseOrderInTransitError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unlockPurchaseOrderInTransitResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editPurchaseOrderInTransit(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockPurchaseOrderInTransitError = (error) => {
    ShowError("Error : ", error);
  };
  getHeaderView() {
    return (
      <PurchaseOrderInTransitForm
        {...this.state}
        save={this.save}
        clearError={this.clearError}
        savePurchaseOrderInTransit={this.savePurchaseOrderInTransit}
        onChange={this.onChange}
        purchaseOrderOnChange={this.purchaseOrderOnChange}
        editPurchaseOrderInTransitLine={this.editPurchaseOrderInTransitLine}
        editPurchaseOrderInTransitRollLine={
          this.editPurchaseOrderInTransitRollLine
        }
        onPurchaseOrderInTransitLineChange={
          this.onPurchaseOrderInTransitLineChange
        }
        onPurchaseOrderInTransitRollLineChange={
          this.onPurchaseOrderInTransitRollLineChange
        }
        addOrUpdatePurchaseOrderInTransitRollLine={
          this.addOrUpdatePurchaseOrderInTransitRollLine
        }
        addOrUpdatePurchaseOrderInTransitLine={
          this.addOrUpdatePurchaseOrderInTransitLine
        }
        addNewRollLine={this.addNewRollLine}
        getPurchaseOrderLinesDatasFromExcel={
          this.getPurchaseOrderInTransitLinesDatasFromExcel
        }
        uploadExcelFile={this.uploadExcelFile}
        cancelPurchaseInTransitLine={this.cancelPurchaseInTransitLine}
        cancelPurchaseInTransitRollLine={this.cancelPurchaseInTransitRollLine}
        purchaseOrderEnterKeyEventHandler={
          this.purchaseOrderEnterKeyEventHandler
        }
        displayAutoCompletePurchaseOrderList={
          this.displayAutoCompletePurchaseOrderList
        }
        hideAlertCallBacklvl5={this.hideAlertCallBacklvl5}
        clearRollLineDetails={this.clearRollLineDetails}
        showRollLinePopup={this.showRollLinePopup}
        closeRollLinePopup={this.closeRollLinePopup}
        showLinePopup={this.showLinePopup}
        closeLinePopup={this.closeLinePopup}
        closeAlertModalCallBack={this.closeAlertModalCallBack}
        closeLvl5ModalCallBack={this.closeLvl5ModalCallBack}
        closeModalCallBack={this.closeModalCallBack}
        lnkPOModule={this.lnkPOModule}
        onLineChange={this.onLineChange}
        locationOnChange={this.locationOnChange}
        locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
        displayLocationAutoCompleteList={this.displayLocationAutoCompleteList}
        fobCityOnChange={this.fobCityOnChange}
        fobCityEnterKeyEventHandler={this.fobCityEnterKeyEventHandler}
        displayFobCityAutoCompleteList={this.displayFobCityAutoCompleteList}
        shipmentTermOnChange={this.shipmentTermOnChange}
        shipmentTermEnterKeyEventHandler={this.shipmentTermEnterKeyEventHandler}
        displayShipmentTermAutoCompleteList={
          this.displayShipmentTermAutoCompleteList
        }
        shipViaOnChange={this.shipViaOnChange}
        shipViaEnterKeyEventHandler={this.shipViaEnterKeyEventHandler}
        displayShipViaAutoCompleteList={this.displayShipViaAutoCompleteList}
        hideAlertCallBacklvl1={this.hideAlertCallBacklvl1}
        isModifyPosible={this.isModifyPosible}
        toRollLineStatus={this.toRollLineStatus}
        onRollLineCancelReasonContinue={this.onRollLineCancelReasonContinue}
        onReasonChange={this.onReasonChange}
      />
    );
  }
  getHistoryView() {
    return (
      <PurchaseOrderInTransitHistoryDetailsForm
        {...this.state}
        purchaseOrderInTransitData={this.state.purchaseOrderInTransitData}
      />
    );
  }
  getDocumentFormView = () => {
    return (
      <MutilpleDocuments
        {...this.state}
        purchaseOrderInTransitData={this.state.purchaseOrderInTransitData}
        documents={this.state.documents}
        // onChange={this.onChange}
        showToast={this.showToast}
        uploadMutiDouments={this.uploadMutiDouments}
        uploadMutiDoumentsUrl={this.uploadMutiDoumentsUrl}
        deleteMultiDocument={this.deleteMultiDocument}
      />
    );
  };
  deleteMultiDocument = (rowData) => {
    let docs =
      this.state.purchaseOrderInTransitData.purchaseOrderInTransitDocuments;
    if (!isEmptyArray(docs)) {
      for (let j = 0; j < docs.length; j++) {
        if (docs[j].documentName === rowData.documentName) {
          if (docs[j].isFetched == true) {
            docs[j].deleted = true; // Change the value at index 2
            docs[j].isDeleted = true;
          } else {
            docs.splice(j, 1); // Change the value at index 2
            this.state.documents.splice(j, 1);
          }
        }
      }
    }
    this.state.purchaseOrderInTransitData.purchaseOrderInTransitDocuments =
      docs;
  };
  uploadMutiDoumentsUrl = (url) => {
    setTimeout(() => {
      this.setState({
        preview_Docs: url,
      });
    }, 400);
  };

  uploadMutiDouments = (docs) => {
    let purchaseOrderInTransitData = this.state.purchaseOrderInTransitData;
    let documents = new Array();
    let docmentData = null;
    for (const doc of docs) {
      if (!doc.isFetched) {
        docmentData = new PurchaseOrderInTransitDocumentBean();
        docmentData.documentOriginalName = doc.name;
        docmentData.documentName = doc.name;
        docmentData.companyCode = this.companyCode;
        docmentData.purchaseOrderInTransitNumber =
          purchaseOrderInTransitData.code;
        docmentData.documentPath = DOCUMENT_CHANGED;
        documents.push(docmentData);
      } else {
        documents.push(doc);
      }
    }
    purchaseOrderInTransitData.purchaseOrderInTransitDocuments = documents;
    this.setState({
      purchaseOrderInTransitData: purchaseOrderInTransitData,
      documents: docs,
    });
  };
  getImageView() {
    return (
      <PurchaseOrderInTransitImageForm
        {...this.state}
        purchaseOrderInTransitData={this.state.purchaseOrderInTransitData}
        showToast={this.showToast}
        setMultiImageUrl={this.setMultiImageUrl}
        setMultiImgData={this.setMultiImgData}
        uploadMutiImage={this.uploadMutiImage}
        deleteMutipleImage={this.deleteMutipleImage}
        addImageLines={this.addImageLines}
        clearImageLines={this.clearImageLines}
      />
    );
  }
  setMultiImageUrl = (url) => {
    setTimeout(() => {
      this.setState({
        preview_Url: url,
      });
    }, 300);
  };
  setMultiImgData = (data) => {
    // this.setState({

    setTimeout(() => {
      this.setState({
        images: data,
      });
    }, 400);
    //   images: data,
    // });
  };
  uploadMutiImage = (images) => {
    let purchaseOrderInTransitData = this.state.purchaseOrderInTransitData;
    let purchaseOrderInTransitImages = new Array();
    let imageData = null;
    for (const img of images) {
      if (!img.isFetched && !img.isDeleted) {
        imageData = new PurchaseOrderInTransitImageBean();

        // imageData.imagePart = imagePart;
        if (!isEmpty(img.imageCode)) {
          imageData.imageCode = img.imageCode;
          imageData.imageOritinalname = img.name;
          imageData.imageName = img.name;
          imageData.isFetched = true;
          imageData.isApplied = true;
        } else {
          imageData.imageOritinalname = img.name;
          imageData.imageName = img.name;
        }
        imageData.companyCode = this.companyCode;
        imageData.purchaseOrderInTransitNumber =
          purchaseOrderInTransitData.code;
        purchaseOrderInTransitImages.push(imageData);
      } else {
        if (img.isFetched == true) {
          purchaseOrderInTransitImages.push(img);
        }
      }
    }
    purchaseOrderInTransitData.purchaseOrderInTransitImages =
      purchaseOrderInTransitImages;
    this.setState({
      purchaseOrderInTransitData: purchaseOrderInTransitData,
      images: images,
    });
  };
  deleteMutipleImage = (tempIndex) => {
    let orderImages =
      this.state.purchaseOrderInTransitData.purchaseOrderInTransitImages;
    if (!isEmptyArray(orderImages)) {
      for (let j = 0; j < orderImages.length; j++) {
        if (j === tempIndex) {
          if (orderImages[j].isFetched == true) {
            orderImages[j].deleted = true; // Change the value at index 2
            orderImages[j].isDeleted = true;
          } else {
            orderImages.splice(j, 1); // Change the value at index 2
            this.state.images.splice(j, 1);
          }
        }
      }
    }
    this.state.purchaseOrderInTransitData.purchaseOrderInTransitImages =
      orderImages;
  };
  addImageLines = (imageEntity) => {
    let purchaseOrderInTransitData = this.state.purchaseOrderInTransitData;
    purchaseOrderInTransitData.purchaseOrderInTransitImages.map((det) => {
      if (det.imageName == imageEntity.imageName) {
        det.tags = imageEntity.tags;
        det.notesCommunication = imageEntity.notesCommunication;
      }
    });
    this.setState({
      purchaseOrderInTransitData: purchaseOrderInTransitData,
    });
  };
  // clearImageLines
  clearImageLines = (imageEntity) => {
    let purchaseOrderInTransitData = this.state.purchaseOrderInTransitData;
    purchaseOrderInTransitData.purchaseOrderInTransitImages.map((det) => {
      if (det.imageName == imageEntity.imageName) {
        det.tags = "";
        det.notesCommunication = "";
      }
    });
    this.setState({
      purchaseOrderInTransitData: purchaseOrderInTransitData,
    });
  };
  showToast = (msg, type) => {
    let errList = [];
    if (type === 1) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (type === 2) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getModuleListView = () => {
    let purchaseOrderInTransitData = this.state.purchaseOrderInTransitData;
    if (purchaseOrderInTransitData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadPurchaseOrderInTransitPage();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockPurchaseOrderInTransit(purchaseOrderInTransitData.code);
      } else {
        this.isLocked = false;
      }

      this.closeEntryForm();
      this.loadPurchaseOrderInTransitPage();
    }
  };
  resetView = () => {
    let purchaseInTransitData = this.state.purchaseOrderInTransitData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode)
        this.unlockPurchaseOrderInTransit(purchaseInTransitData.code);
    } else {
      this.isLocked = false;
    }
    let purchaseOrderInTransitData = new PurchaseOrderInTransitBean();
    this.setState({
      purchaseOrderInTransitData: purchaseOrderInTransitData,
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isFocus: false,
      disabledFormFields: false,
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.hideAlertCallBack();
    this.addNewEntry();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  selectButtonClick = (e) => {
    this.editPurchaseOrderInTransit(this.state.moduleKeyCode);
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  getCriteriaString = () => {
    let criteriaString = "";
    let moduleCaption = this.moduleCaption;
    if (this.state.criteria == null) {
      return <div />;
    } else {
      if (!isEmptyString(this.state.criteria.purchaseOrderInTransitNumber))
        criteriaString =
          criteriaString +
          moduleCaption +
          "PR# : " +
          this.state.criteria.purchaseOrderInTransitNumber +
          " ; ";
      if (
        !isEmptyString(
          this.state.criteria.purchaseOrderInTransitNumberStartsWith,
        )
      )
        criteriaString =
          criteriaString +
          moduleCaption +
          "purchaseOrderInTransitNumberStartsWith : " +
          this.state.criteria.purchaseOrderInTransitNumberStartsWith +
          " ; ";
      if (
        !isEmptyString(this.state.criteria.purchaseOrderInTransitNumberContains)
      )
        criteriaString =
          criteriaString +
          moduleCaption +
          "purchaseOrderInTransitNumberContains: " +
          this.state.criteria.purchaseOrderInTransitNumberContains +
          " ; ";

      if (!isEmptyString(this.state.criteria.purchaseOrderNumber))
        criteriaString =
          criteriaString +
          "purchaseOrderNumber : " +
          this.state.criteria.purchaseOrderNumber +
          " ; ";
      if (!isEmptyString(this.state.criteria.vendorCode))
        criteriaString =
          criteriaString +
          "vendorCode : " +
          this.state.criteria.vendorCode +
          " ; ";
    }
    return <div>{criteriaString}</div>;
  };
  moduleExit = () => {
    let purchaseInTransitData = this.state.purchaseOrderInTransitData;
    if (purchaseInTransitData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockPurchaseOrderInTransit(purchaseInTransitData.code);
      } else {
        this.isLocked = false;
      }
      this.props.onModuleExit();
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  generatePDF = (e) => {
    if (e.detail == 1) {
      this.setState({
        isLoading: true,
        loadingText: "Generating PDF",
      });
      this.downloadReport(1, this.state.purchaseOrderInTransitData.code);
    }
  };
  downloadReportResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    if (response.data != null && response.data.reportResult != null) {
      let reportFilePath = response.data.reportResult.reportFileID;
      if (reportFilePath != null) {
        window.open(this.report_url + reportFilePath);
      }
    }
  };
  downloadReportError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  downloadReport = (reportType, code) => {
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;

    let requestInput = new InTransitPackingListPrintRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.purchaseOrderInTransitNumber = code;
    if (
      SecurityAccessManager.PurchaseOrderInTransitMaintenancePDFReport_IsAccessible()
    ) {
      ReportService.generateInTransitPackingListPrintReport(
        requestInput,
        this.downloadReportResponse,
        this.downloadReportError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  reArrangePurchaseIntransitLineNumbers = (LineList) => {
    let maxLineNumber = 0;
    LineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
      //}
    });
  };
  cancelPurchaseInTransitLine = (inTransitLine) => {
    let purchaseOrderInTransitData = this.state.purchaseOrderInTransitData;

    let purchaseOrderInTransitLineData = inTransitLine;
    let existingLine = this.getInTransitLinebyLineNumber(
      inTransitLine.lineNumber,
    );
    this.state.purchaseOrderInTransitLineData = { ...existingLine };
    if (!isEmpty(existingLine)) {
      if (!existingLine.isFetched) {
        const index = purchaseOrderInTransitData.lines.findIndex(
          (ln) => ln.lineNumber === existingLine.lineNumber,
        );
        if (index != -1) {
          purchaseOrderInTransitData.lines.splice(index, 1);
        }
        this.reArrangePurchaseIntransitLineNumbers(
          purchaseOrderInTransitData.lines,
        );
        this.setState({
          purchaseOrderInTransitData: purchaseOrderInTransitData,
        });
      } else {
        this.openReasonCapture(3);
      }
    }

    this.setState({
      purchaseOrderInTransitLineData: purchaseOrderInTransitLineData,
    });
  };
  getInTransitLinebyLineNumber = (lineNumber) => {
    let inTransitLine = null;
    if (this.state.purchaseOrderInTransitData === null) return inTransitLine;
    else if (this.state.purchaseOrderInTransitData.lines === null)
      return inTransitLine;
    else {
      this.state.purchaseOrderInTransitData.lines.map((line) => {
        if (line.lineNumber === lineNumber) {
          inTransitLine = line;
          return inTransitLine;
        }
      });
    }
    return inTransitLine;
  };

  onLineCancelReasonContinue = () => {
    this.savePurchaseInTransitLineCancel();
    this.closeReasonModelCallBack();
  };
  onRollLineCancelReasonContinue = () => {
    this.savePurchaseInTransitRollLineCancel();
    this.closeReasonModelCallBack();
  };
  savePurchaseInTransitLineCancel = () => {
    let purchaseOrderInTransitLineData =
      this.state.purchaseOrderInTransitLineData;
    let purchaseOrderInTransitRollLineData =
      this.state.purchaseOrderInTransitRollLineData;
    let input = new RestPurchaseOrderInTransitBeanRequest();
    let temp_purchaseOrderInTransitSearchCriteria =
      new PurchaseOrderInTransitLineSearchCriteria();
    temp_purchaseOrderInTransitSearchCriteria.companyCode = this.companyCode;
    temp_purchaseOrderInTransitSearchCriteria.purchaseOrderNumber =
      purchaseOrderInTransitLineData.purchaseOrderNumber;
    temp_purchaseOrderInTransitSearchCriteria.purchaseOrderLineNumber =
      purchaseOrderInTransitLineData.purchaseOrderLineNumber;
    temp_purchaseOrderInTransitSearchCriteria.purchaseOrderInTransitNumber =
      purchaseOrderInTransitLineData.purchaseOrderInTransitNumber;
    temp_purchaseOrderInTransitSearchCriteria.purchaseOrderInTransitLineNumber =
      purchaseOrderInTransitLineData.lineNumber;
    temp_purchaseOrderInTransitSearchCriteria.purchaseOrderInTransitRollLineNumber =
      purchaseOrderInTransitRollLineData.inTransitRollLineNumber;
    input.companyCode = this.companyCode;
    input.searchCriteria = temp_purchaseOrderInTransitSearchCriteria;
    input.reason = this.state.reasonData;
    input.isLockRequired = true;
    if (
      SecurityAccessManager.PurchaseOrderInTransitMaintenanceLineCancel_IsAccessible()
    ) {
      PurchaseOrderInTransitService.cancelPurchaseOrderInTransitLine(
        input,
        this.savePurchaseOrderLineCancelResponse,
        this.savePurchaseOrderLineCancelError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  savePurchaseOrderLineCancelResponse = (response) => {
    this.handleresponse(response.data);

    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.purchaseOrderinTransit.lines)
    ) {
      let purchaseOrderinTransit = response.data.purchaseOrderinTransit;
      this.setState({
        purchaseOrderInTransitData: purchaseOrderinTransit,
      });
      // this.unlockPurchaseOrderInTransit(purchaseOrderinTransit.code);
      // this.editPurchaseOrderInTransit(
      //   response.data.purchaseOrderinTransit.code
      // );
      if (this.isLocked) {
        this.code = purchaseOrderinTransit.code;
        this.unlockPurchaseOrderInTransit(purchaseOrderinTransit.code);
      }
    }
  };
  savePurchaseOrderLineCancelError = (error) => {
    ShowError("Error cancel line: " + error);
  };
  reArrangeRollLineDisplayNumbers = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.inTransitRollLineNumber = maxLineNumber;
    });
  };
  // cancelPurchaseInTransitRollLine = (inTransitRollLine) => {
  //   let purchaseOrderInTransitLineData =
  //     this.state.purchaseOrderInTransitLineData;
  //   let poInTransitRollLinesList = this.state.poInTransitRollLinesList;
  //   let purchaseOrderInTransitRollLineData = inTransitRollLine;
  //   let existingLine = this.getInTransitRollLinebyLineNumber(
  //     inTransitRollLine.inTransitRollLineNumber,
  //   );
  //   if (!isEmpty(existingLine)) {
  //     if (!existingLine.isFetched) {
  //       const index = poInTransitRollLinesList.findIndex(
  //         (ln) =>
  //           ln.inTransitRollLineNumber === existingLine.inTransitRollLineNumber,
  //       );
  //       if (index != -1) {
  //         poInTransitRollLinesList.splice(index, 1);
  //       }
  //       this.reArrangeRollLineDisplayNumbers(poInTransitRollLinesList);
  //       this.setInTransitQtyValues(poInTransitRollLinesList);
  //       this.state.poInTransitRollLinesList = poInTransitRollLinesList;
  //     } else {
  //       this.openReasonCapture(4);
  //       this.setState({
  //         purchaseOrderInTransitLineData: purchaseOrderInTransitLineData,
  //       });
  //     }
  //   }
  //   this.setState({
  //     purchaseOrderInTransitRollLineData: purchaseOrderInTransitRollLineData,
  //   });
  // };

  cancelPurchaseInTransitRollLine = (inTransitRollLine) => {
    const existingLine = this.getInTransitRollLinebyLineNumber(
      inTransitRollLine.inTransitRollLineNumber,
    );

    if (!isEmpty(existingLine)) {
      if (!existingLine.isFetched) {
        // ✅ Create a new array instead of mutating in place
        const updatedRollLines = this.state.poInTransitRollLinesList.filter(
          (ln) =>
            ln.inTransitRollLineNumber !== existingLine.inTransitRollLineNumber,
        );

        this.reArrangeRollLineDisplayNumbers(updatedRollLines);

        // ✅ Recalculate quantity from the new list
        let inTransitQuantity = 0;
        updatedRollLines.forEach((roll) => {
          inTransitQuantity += parseFloat(roll.inTransitQuantity) || 0;
        });

        // ✅ Update both the roll lines list AND the line quantity in one setState
        const purchaseOrderInTransitLineData = {
          ...this.state.purchaseOrderInTransitLineData,
          inTransitQuantity: inTransitQuantity.toFixed(2),
          totalRolls: updatedRollLines.length,
        };

        this.setState({
          poInTransitRollLinesList: updatedRollLines,
          purchaseOrderInTransitLineData,
          purchaseOrderInTransitRollLineData: inTransitRollLine,
        });
      } else {
        this.openReasonCapture(4);
        this.setState({
          purchaseOrderInTransitRollLineData: inTransitRollLine,
        });
      }
    }
  };

  setInTransitQtyValues = (lines) => {
    let purchaseOrderInTransitLineData =
      this.state.purchaseOrderInTransitLineData;
    let inTransitQuantity = 0;
    if (!isEmptyArray(lines)) {
      lines.map((roll) => {
        inTransitQuantity =
          inTransitQuantity + parseFloat(roll.inTransitQuantity);
      });
    }
    purchaseOrderInTransitLineData.inTransitQuantity =
      inTransitQuantity.toFixed(2);
    purchaseOrderInTransitLineData.totalRolls = lines.length;
    this.setState({
      purchaseOrderInTransitLineData: purchaseOrderInTransitLineData,
    });
  };

  getInTransitRollLinebyLineNumber = (inTransitRollLineNumber) => {
    let inTransitLine = null;
    if (this.state.purchaseOrderInTransitLineData === null)
      return inTransitLine;
    else if (this.state.poInTransitRollLinesList === null) return inTransitLine;
    else {
      if (!isEmptyArray(this.state.poInTransitRollLinesList)) {
        this.state.poInTransitRollLinesList.map((line) => {
          if (line.inTransitRollLineNumber === inTransitRollLineNumber) {
            inTransitLine = line;
            return inTransitLine;
          }
        });
      }
    }
    return inTransitLine;
  };

  savePurchaseInTransitRollLineCancel = () => {
    let purchaseOrderInTransitRollLineData =
      this.state.purchaseOrderInTransitRollLineData;
    let input = new RestPurchaseOrderInTransitRollLineRequest();
    let purchaseOrderInTransitRollLineSearchCriteria =
      new PurchaseOrderInTransitRollLineSearchCriteria();
    purchaseOrderInTransitRollLineSearchCriteria.companyCode = this.companyCode;
    purchaseOrderInTransitRollLineSearchCriteria.purchaseOrderNumber =
      purchaseOrderInTransitRollLineData.purchaseOrderNumber;
    purchaseOrderInTransitRollLineSearchCriteria.purchaseOrderInTransitNumber =
      purchaseOrderInTransitRollLineData.purchaseOrderInTransitNumber;
    purchaseOrderInTransitRollLineSearchCriteria.purchaseOrderInTransitLineNumber =
      purchaseOrderInTransitRollLineData.inTransitLineNumber;
    purchaseOrderInTransitRollLineSearchCriteria.purchaseOrderInTransitRollLineNumber =
      purchaseOrderInTransitRollLineData.inTransitRollLineNumber;

    input.companyCode = this.companyCode;
    input.searchCriteria = purchaseOrderInTransitRollLineSearchCriteria;
    input.reason = this.state.reasonData;
    input.isLockRequired = false;
    if (
      SecurityAccessManager.PurchaseOrderInTransitMaintenanceLineCancel_IsAccessible()
    ) {
      PurchaseOrderInTransitService.cancelPurchaseOrderInTransitRollLine(
        input,
        this.savePurchaseOrderRollLineCancelResponse,
        this.savePurchaseOrderRollLineCancelError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  savePurchaseOrderRollLineCancelResponse = (response) => {
    this.handlePopupResponse(response.data);
    if (response.data != null && response.data.purchaseOrderinTransit != null) {
      let purchaseOrderInTransitData = response.data.purchaseOrderinTransit;
      this.setState({
        purchaseOrderInTransitData: purchaseOrderInTransitData,
      });
      this.closeAlertModalCallBack(false);
      // this.unlockPurchaseOrderInTransit(purchaseOrderInTransitData.code);
      // this.editPurchaseOrderInTransit(purchaseOrderInTransitData.code);
      if (this.isLocked) {
        this.code = purchaseOrderInTransitData.code;
        this.unlockPurchaseOrderInTransit(purchaseOrderInTransitData.code);
      }
    }
  };

  savePurchaseOrderRollLineCancelError = (error) => {
    ShowError("Error cancel line: " + error);
  };
  locationOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.isShowAutoCompleteLocationList = true;
    let tempCriteria = this.state.purchaseOrderInTransitData;
    let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.isShowAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
      let tempCriteria = this.state.purchaseOrderInTransitData;
      tempCriteria.locationCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderInTransitData: tempCriteria,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "locationCode" &&
      showAutoCompleteList === true &&
      locationCode !== ""
    ) {
      this.readLocationBySearchString(e.target.value);
    }
    this.readLocation(locationCode);
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderInTransitData: tempCriteria });
  };
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.state.isShowAutoCompleteLocationList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayLocationAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteLocationList: isShowAutoCompleteList,
    });
  };
  readLocation = (locationCode) => {
    let tempCriteria = this.state.purchaseOrderInTransitData;
    let locationBean = null;
    let locationData = null;
    this.state.wareHouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      tempCriteria.locationCode = locationBean.code;
      this.state.isShowAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
      this.setState({
        purchaseOrderInTransitData: tempCriteria,
        isShowAutoCompleteLocationList: showAutoCompleteList,
      });
    }
  };
  readLocationBySearchString = (searchString) => {
    let locationData = this.state.wareHouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((location) => {
        let locationBean = {
          code: location.code,
          description: location.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      locationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  fobCityOnChange = (e) => {
    let fOBCity = e.target.value;
    this.state.isShowAutoCompleteFobCityList = true;
    let tempCriteria = this.state.purchaseOrderInTransitData;
    let showAutoCompleteList = this.state.isShowAutoCompleteFobCityList;
    if (isEmpty(fOBCity)) {
      this.state.isShowAutoCompleteFobCityList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteFobCityList;
      let tempCriteria = this.state.purchaseOrderInTransitData;
      tempCriteria.fOBCity = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderInTransitData: tempCriteria,
        FobCityPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fOBCity" &&
      showAutoCompleteList === true &&
      fOBCity !== ""
    ) {
      this.readFobCityBySearchString(e.target.value);
    }
    this.readFobCity(fOBCity);
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderInTransitData: tempCriteria });
  };

  fobCityEnterKeyEventHandler = (e) => {
    let fOBCity = e.target.value;
    this.readFobCity(fOBCity);
    this.state.isShowAutoCompleteFobCityList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteFobCityList;
    this.setState({
      FobCityPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayFobCityAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteFobCityList: isShowAutoCompleteList,
    });
  };
  readFobCity = (fOBCity) => {
    let tempCriteria = this.state.purchaseOrderInTransitData;
    let fobCityBean = null;
    let fobCityData = null;
    this.state.fOBCities.map((ln) => {
      if (ln.code === fOBCity) {
        fobCityBean = ln;
        fobCityData = new BaseBean();
        fobCityData.code = ln.code;
        fobCityData.description = ln.description;
      }
    });
    if (!isEmpty(fobCityBean)) {
      tempCriteria.fOBCity = fobCityBean.code;
      this.state.isShowAutoCompleteFobCityList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteFobCityList;
      this.setState({
        purchaseOrderInTransitData: tempCriteria,
        isShowAutoCompleteFobCityList: showAutoCompleteList,
      });
    }
  };
  readFobCityBySearchString = (searchString) => {
    let fobCityData = this.state.fOBCities;
    let simpleAutoCompleteList = new Array();
    if (fobCityData.length > 0 && fobCityData != null) {
      fobCityData.map((fobCity) => {
        let fobCityBean = {
          code: fobCity.code,
          description: fobCity.description,
        };
        simpleAutoCompleteList.push(fobCityBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      FobCityPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  shipmentTermOnChange = (e) => {
    let shipmentTermsCode = e.target.value;
    this.state.isShowAutoCompleteShipmentTermList = true;
    let tempCriteria = this.state.purchaseOrderInTransitData;
    let showAutoCompleteList = this.state.isShowAutoCompleteShipmentTermList;
    if (isEmpty(shipmentTermsCode)) {
      this.state.isShowAutoCompleteShipmentTermList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteShipmentTermList;
      let tempCriteria = this.state.purchaseOrderInTransitData;
      tempCriteria.shipmentTermsCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderInTransitData: tempCriteria,
        shipmentTermPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "shipmentTermsCode" &&
      showAutoCompleteList === true &&
      shipmentTermsCode !== ""
    ) {
      this.readShipmentTermBySearchString(e.target.value);
    }
    this.readShipmentTerm(shipmentTermsCode);
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderInTransitData: tempCriteria });
  };

  shipmentTermEnterKeyEventHandler = (e) => {
    let shipmentTermsCode = e.target.value;
    this.readShipmentTerm(shipmentTermsCode);
    this.state.isShowAutoCompleteShipmentTermList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteShipmentTermList;
    this.setState({
      shipmentTermPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayShipmentTermAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteShipmentTermList: isShowAutoCompleteList,
    });
  };
  readShipmentTerm = (shipmentTermsCode) => {
    let tempCriteria = this.state.purchaseOrderInTransitData;
    let shipmentTermBean = null;
    let shipmentTermData = null;
    this.state.shipmentTerms.map((ln) => {
      if (ln.code === shipmentTermsCode) {
        shipmentTermBean = ln;
        shipmentTermData = new BaseBean();
        shipmentTermData.code = ln.code;
        shipmentTermData.description = ln.description;
      }
    });
    if (!isEmpty(shipmentTermBean)) {
      tempCriteria.shipmentTermsCode = shipmentTermBean.code;
      this.state.isShowAutoCompleteShipmentTermList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteShipmentTermList;
      this.setState({
        purchaseOrderInTransitData: tempCriteria,
        isShowAutoCompleteShipmentTermList: showAutoCompleteList,
      });
    }
  };
  readShipmentTermBySearchString = (searchString) => {
    let shipmentTermData = this.state.shipmentTerms;
    let simpleAutoCompleteList = new Array();
    if (shipmentTermData.length > 0 && shipmentTermData != null) {
      shipmentTermData.map((shipmentTerm) => {
        let shipmentTermBean = {
          code: shipmentTerm.code,
          description: shipmentTerm.description,
        };
        simpleAutoCompleteList.push(shipmentTermBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      shipmentTermPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  shipViaOnChange = (e) => {
    let shipViaCode = e.target.value;
    this.state.isShowAutoCompleteShipViaList = true;
    let tempCriteria = this.state.purchaseOrderInTransitData;
    let showAutoCompleteList = this.state.isShowAutoCompleteShipViaList;
    if (isEmpty(shipViaCode)) {
      this.state.isShowAutoCompleteShipViaList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteShipViaList;
      let tempCriteria = this.state.purchaseOrderInTransitData;
      tempCriteria.shipViaCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderInTransitData: tempCriteria,
        shipViaPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "shipViaCode" &&
      showAutoCompleteList === true &&
      shipViaCode !== ""
    ) {
      this.readShipViaBySearchString(e.target.value);
    }
    this.readShipVia(shipViaCode);
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderInTransitData: tempCriteria });
  };
  shipViaEnterKeyEventHandler = (e) => {
    let shipViaCode = e.target.value;
    this.readShipVia(shipViaCode);
    this.state.isShowAutoCompleteShipViaList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteShipViaList;
    this.setState({
      shipViaPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayShipViaAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteShipViaList: isShowAutoCompleteList,
    });
  };
  readShipVia = (shipViaCode) => {
    let tempCriteria = this.state.purchaseOrderInTransitData;
    let shipViaBean = null;
    let shipViaData = null;
    this.state.shipVias.map((ln) => {
      if (ln.code === shipViaCode) {
        shipViaBean = ln;
        shipViaData = new BaseBean();
        shipViaData.code = ln.code;
        shipViaData.description = ln.description;
      }
    });
    if (!isEmpty(shipViaBean)) {
      tempCriteria.shipViaCode = shipViaBean.code;
      this.state.isShowAutoCompleteShipViaList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteShipViaList;
      this.setState({
        purchaseOrderInTransitData: tempCriteria,
        isShowAutoCompleteShipViaList: showAutoCompleteList,
      });
    }
  };
  readShipViaBySearchString = (searchString) => {
    let shipViaData = this.state.shipVias;
    let simpleAutoCompleteList = new Array();
    if (shipViaData.length > 0 && shipViaData != null) {
      shipViaData.map((shipVia) => {
        let shipViaBean = {
          code: shipVia.code,
          description: shipVia.description,
        };
        simpleAutoCompleteList.push(shipViaBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      shipViaPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  closeAlertProgressBarModalCallBack = (isShowPopup) => {
    this.setState({
      isShowProgressBarPopup: isShowPopup,
    });
  };
  clearRollLineDetails = () => {
    let rollData = new PurchaseOrderInTransitRollLineBean();
    this.setState({ purchaseOrderInTransitRollLineData: rollData });
    this.addNewRollLine();
  };
  showRollLinePopup = () => {
    this.setState({
      isShowRollLinePopup: true,
    });
  };
  closeRollLinePopup = () => {
    this.setState({
      isShowRollLinePopup: false,
    });
  };
  showLinePopup = () => {
    this.setState({ isShowPopup: true });
  };
  closeLinePopup = () => {
    this.setState({
      isShowPopup: false,
      poInTransitRollLinesList: new Array(),
    });
  };
  lnkPOModule = () => {
    let purchaseOrderInTransitData = this.state.purchaseOrderInTransitData;
    let code = purchaseOrderInTransitData.purchaseOrderNumber;
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPurchaseOrderModule: true,
        moduleForPopup: (
          <PopupPurchaseOrderModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  onLineChange = (e) => {
    let temp_addressBean = this.state.purchaseOrderInTransitListData;
    if (temp_addressBean == null || temp_addressBean == "undefined") {
      temp_addressBean = new AddressBean();
    }
    temp_addressBean[e.target.name] = e.target.value;
    this.setState({ purchaseOrderInTransitListData: temp_addressBean });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({ isShowPurchaseOrderModule: isOpen, moduleForPopup: [] });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.state.poInTransitRollLinesList = [];
    this.setInTransitDataValues();
    this.setState({
      isShowPopup: isShowPopup,
      poInTransitRollLinesList: new Array(),
      isShowPopupAlertlvl1: isShowPopup,
      isShowPopupAlertlvl5: isShowPopup,
    });
  };
  setInTransitDataValues = () => {
    let intransitLineData = this.state.purchaseOrderInTransitLineData;
    let intransitQty = 0;
    intransitLineData.inTransitRollLines.map((ln) => {
      intransitQty += parseFloat(ln.inTransitQuantity);
    });
    intransitLineData.inTransitQuantity = intransitQty.toFixed(2);
    intransitLineData.totalRolls = intransitLineData.inTransitRollLines.length;
    this.setState({
      purchaseOrderInTransitLineData: intransitLineData,
    });
  };
  closeLvl5ModalCallBack = (isShowPopup) => {
    this.setState({
      isShowRollLinePopup: false,
    });
  };
  hideAlertCallBacklvl1 = (msgType, isDisplayed) => {
    this.setState({ isShowPopupAlertlvl1: isDisplayed });
  };
  hideAlertCallBacklvl5 = (msgType, isDisplayed) => {
    this.setState({ isShowPopupAlertlvl5: isDisplayed });
  };
  ListFormOnChange = (e) => {
    let criteria = this.state.criteria;

    criteria[e.target.name] = e.target.value;

    this.setState({ criteria: criteria });
  };
  resetfilteredPurchaseOrderInTransit = () => {
    let criteria = new PurchaseOrderInTransitSearchCriteria();
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };
  handlePurchaseOrderInTransitCodeChange = (e) => {
    this.setState({ filter: e.target.value });
  };
  filterPurchaseOrderInTransit = () => {
    this.loadPage(1);
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder =
      accessor === this.state.sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let purchaseOrderInTransitListData =
      this.state.purchaseOrderInTransitListData;
    if (sortField && !isEmptyArray(purchaseOrderInTransitListData)) {
      const sorted = [...purchaseOrderInTransitListData].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ purchaseOrderInTransitListData: sorted });
    }
  };
  render() {
    let moduleOrderStatus = this.state.moduleOrderStatus;
    return (
      <div>
        <ProgressBar
          closeAlertModalCallBack={this.closeAlertProgressBarModalCallBack}
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <ReasonCaptureComponent
          ref={this.lineCancelReasonDialogRef}
          reasons={this.state.cancelReason}
          reasonData={this.state.reasonData}
          title="PurchaseOrder InTransit Line Cancel"
          onChange={this.onReasonChange}
          onClick={this.onLineCancelReasonContinue}
          isShowPopup={this.state.isShowLineCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        <ReasonCaptureComponent
          ref={this.rollLineCancelReasonDialogRef}
          reasons={this.state.cancelReason}
          reasonData={this.state.reasonData}
          title="PurchaseOrder InTransit Roll Line Cancel"
          onChange={this.onReasonChange}
          onClick={this.onRollLineCancelReasonContinue}
          isShowPopup={this.state.isShowRollLineCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        {this.state.isSpecialViewMode == false ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editPurchaseOrderInTransit}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.purchaseOrderInTransitLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isSpecialViewMode={this.state.isSpecialViewMode}
          isResetView={this.state.isResetView}
        />

        {!this.state.isPurchaseOrderInTransitListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              pageTitle={this.state.pageTitle}
              save={this.save}
              isShowSaveButton={this.state.isShowSaveButton}
              clearError={this.clearError}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              extend_toolbar={
                <>
                  {this.state.isShowUnApproveButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.unApprovePurchaseOrderInTransit(e)}
                    >
                      UnApprove
                    </Button>
                  )}
                  {this.state.isShowApproveButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.approvePurchaseOrderInTransit(e)}
                    >
                      Approve
                    </Button>
                  )}
                  {this.state.isShowCancelButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.cancelPurchaseOrderInTransit(e)}
                    >
                      Cancel
                    </Button>
                  )}
                  {this.state.isShowInTransitButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.generatePDF(e)}
                    >
                      InTransitPack
                    </Button>
                  )}
                </>
              }
            />
          )}
        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedModuleKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={moduleOrderStatus}
          />
        )}

        {!this.state.isShowNodes &&
          !this.state.isPurchaseOrderInTransitListFormOpen &&
          !this.state.isPurchaseOrderInTransitHistoryFormOpen &&
          this.state.isPurchaseOrderInTransitEntryFormOpen &&
          !this.state.isImageFormOpened &&
          !this.state.isDocumentFormOpened &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderInTransitListFormOpen &&
          this.state.isPurchaseOrderInTransitEntryFormOpen &&
          !this.state.isPurchaseOrderInTransitHistoryFormOpen &&
          !this.state.isImageFormOpened &&
          !this.state.isDocumentFormOpened &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderInTransitListFormOpen &&
          !this.state.isPurchaseOrderInTransitEntryFormOpen &&
          this.state.isPurchaseOrderInTransitHistoryFormOpen &&
          !this.state.isImageFormOpened &&
          !this.state.isDocumentFormOpened &&
          this.getHistoryView()}
        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderInTransitListFormOpen &&
          !this.state.isPurchaseOrderInTransitEntryFormOpen &&
          !this.state.isPurchaseOrderInTransitHistoryFormOpen &&
          this.state.isImageFormOpened &&
          !this.state.isDocumentFormOpened &&
          this.getImageView()}
        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderInTransitListFormOpen &&
          !this.state.isPurchaseOrderInTransitEntryFormOpen &&
          !this.state.isPurchaseOrderInTransitHistoryFormOpen &&
          !this.state.isImageFormOpened &&
          this.state.isDocumentFormOpened &&
          this.getDocumentFormView()}
        {this.state.isPurchaseOrderInTransitListFormOpen &&
          this.state.isSpecialViewMode == false && (
            <PurchaseOrderInTransitListForm
              {...this.state}
              filterPurchaseOrderInTransit={this.filterPurchaseOrderInTransit}
              loadFirst={this.loadFirst}
              loadNext={this.loadNext}
              loadPrevious={this.loadPrevious}
              loadLast={this.loadLast}
              editPurchaseOrderInTransit={this.editPurchaseOrderInTransit}
              ListFormOnChange={this.ListFormOnChange}
              resetfilteredPurchaseOrderInTransit={
                this.resetfilteredPurchaseOrderInTransit
              }
              handlePurchaseOrderInTransitCodeChange={
                this.handlePurchaseOrderInTransitCodeChange
              }
              handleSortingChange={this.handleSortingChange}
            />
          )}
        <ReasonCaptureComponent
          ref={this.cancelReasonDialogRef}
          reasons={this.state.cancelReason}
          reasonData={this.state.reasonData}
          title="PurchaseInTransit Cancel"
          onChange={this.onReasonChange}
          onClick={this.onCancelReasonContinue}
          isShowPopup={this.state.isShowCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        <ReasonCaptureComponent
          ref={this.unapproveReasonDialogRef}
          reasons={this.state.unApproveReason}
          reasonData={this.state.reasonData}
          title="PurchaseInTransit UnApprove"
          onChange={this.onUnApproveReasonChange}
          onClick={this.onUnApproveReasonContinue}
          isShowPopup={this.state.isShowUnApproveReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.unApproveReasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.unApproveReasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={
            this.displayAutoCompleteUnApproveReasonList
          }
          showAutoCompleteReasonList={
            this.state.showAutoCompleteUnApproveReasonList
          }
          onReasonDescChange={this.onReasonDescChange}
        />
      </div>
    );
  }
}
class PurchaseOrderInTransitListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }

  filterPurchaseOrderInTransit = (e) => {
    if (e.detail == 1) this.props.filterPurchaseOrderInTransit();
  };
  ListFormOnChange = (e) => {
    this.props.ListFormOnChange(e);
  };
  resetfilteredPurchaseOrderInTransit = (e) => {
    if (e.detail == 1) this.props.resetfilteredPurchaseOrderInTransit();
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  handlePurchaseOrderInTransitCodeChange = (e) => {
    this.props.handlePurchaseOrderInTransitCodeChange(e);
  };
  editPurchaseOrderInTransit = (e, val, columnDef, row) => {
    if (e.detail == 1) this.props.editPurchaseOrderInTransit(val);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterPurchaseOrderInTransit();
    }
  };

  purchaseIntransitPagePageColumns = () => {
          const columns = new Array();
          columns.push(
            new ColumnDefinition()
              .setDetails("PO Intransit#", "code", true)
              .setStyleDetails("left", "", "", "wt-3", "wt-3")
              .setClickDetails(true, false, this.editPurchaseOrderInTransit, null),
          );
          columns.push(
            new ColumnDefinition()
              .setDetails("Vendor", "vendorCode", true)
              .setStyleDetails("left", "", "", "wt-3", "wt-3"),
          );
          columns.push(
            new ColumnDefinition()
              .setDetails("VendorName", "vendorName", true)
              .setStyleDetails("left", "", "", "wt-3", "wt-3"),
          );
             columns.push(
            new ColumnDefinition()
              .setDetails("InTransitDate", "inTransitDate", true, false, true)
              .setStyleDetails("left", "", "", "wt-3", "wt-3"),
          );
            columns.push(
            new ColumnDefinition()
              .setDetails("Status", "inTransitStatus", true)
              .setStyleDetails("left", "", "", "wt-3", "wt-3")
              .setStatusDetails(true, this.getCaption),
          );
          columns.push(
            new ColumnDefinition()
              .setDetails("ShipmentTerm", "shipmentTermsCode", true)
              .setStyleDetails("left", "", "", "wt-3", "wt-3"),
          );
          columns.push(
            new ColumnDefinition()
              .setDetails("ContainerNumber", "containerNumber", true)
              .setStyleDetails("left", "", "", "wt-3", "wt-3"),
          );
                  columns.push(
            new ColumnDefinition()
              .setDetails("ContainerDetail", "containerDetail", true)
              .setStyleDetails("left", "", "", "wt-3", "wt-3"),
          );
          //       columns.push(
          //   new ColumnDefinition()
          //     .setDetails("OrderType", "orderType", true)
          //     .setStyleDetails("left", "", "", "wt-3", "wt-3")
          // );
          // columns.push(
          //   new ColumnDefinition()
          //     .setDetails("Status", "orderStatus", true)
          //     .setStyleDetails("left", "", "", "wt-3", "wt-3")
          //     .setStatusDetails(true, this.getCaption),
          // );
          // columns.push(
          //   new ColumnDefinition()
          //     .setDetails("BuyingTerms", "buyingTermsCode", true)
          //     .setStyleDetails("left", "", "", "wt-3", "wt-3"),
          // );
          // columns.push(
          //   new ColumnDefinition()
          //     .setDetails("GrandTotalAmt", "grandTotalAmount", true, true)
          //     .setStyleDetails("right", "", "", "wt-3", "wt-3"),
          // );
          return columns;
        };
        getCaption = (status) => {
          return ModuleUtils.getPurchaseOrderInTransitStatusCaption(status);
        };
  render() {
    let purchaseOrderInTransitListData = new Array();
    if (!isEmptyArray(this.props.purchaseOrderInTransitListData))
      purchaseOrderInTransitListData =
        this.props.purchaseOrderInTransitListData;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    return (
      <div>
        <div className="secondary_module_header">
          {/* <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                name="searchName"
                type="text"
                placeholder="Enter Value to Filter.."
                value={criteria.searchName}
                onChange={this.ListFormOnChange}
                onKeyDown={this.onKeyDown}
              />
              <Button onClick={(e) => this.filterPurchaseOrderInTransit(e)}>
                Filter
              </Button>
              <Button
                onClick={(e) => this.resetfilteredPurchaseOrderInTransit(e)}
              >
                Reset
              </Button>
            </span>
          </div> */}
          <div className="mdle-criteria-wrap">
            <div className="">
              <FormLabel className="criteria-labl">Status</FormLabel>
            </div>
            <div className="criteria-val">
              <FormControl
                as="select"
                custom
                onChange={this.ListFormOnChange}
                name="inTransitStatus"
                value={criteria.inTransitStatus}
              >
                <option value={""}>All</option>
                <option
                  value={LogicConstants.PURCHASEORDER_INTRANSIT_APPROVE_STATUS}
                >
                  Approved
                </option>
                <option
                  value={
                    LogicConstants.PURCHASEORDER_INTRANSIT_UNAPPROVE_STATUS
                  }
                >
                  UnApproved
                </option>
                <option
                  value={LogicConstants.PURCHASEORDER_INTRANSIT_RECEIVED_STATUS}
                >
                  Received
                </option>
                <option
                  value={
                    LogicConstants.PURCHASE_ORDER_INTRANSIT_PARTIALLY_RECEIVED_STATUS
                  }
                >
                  Partially Received
                </option>
                <option
                  value={LogicConstants.PURCHASEORDER_INTRANSIT_CANCEL_STATUS}
                >
                  Cancelled
                </option>
              </FormControl>
            </div>
            <div className="">
              <FormLabel className="criteria-labl">Search</FormLabel>
            </div>
            <div className="criteria-val">
              <InputTextbox
                name="searchName"
                type="text"
                placeholder="Enter Value to Filter.."
                value={criteria.searchName}
                onChange={this.ListFormOnChange}
                onKeyDown={this.onKeyDown}
              />
            </div>
            <div className="criteria-btn-wrap ">
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.filterPurchaseOrderInTransit(e)}
              >
                Filter
              </Button>
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.resetfilteredPurchaseOrderInTransit(e)}
              >
                Reset
              </Button>
            </div>
          </div>
          <div className="module_header_secondary_buttons">
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
         <div className="mt-3">
                                  <CustomTable
                                    data={purchaseOrderInTransitListData}
                                    columns={this.purchaseIntransitPagePageColumns()}
                                    enableHighlight={true} // Boolean flag controlling highlight execution
                                    //  searchText={pickTicketCriteria.searchName} // Search input text
                                  />
                                </div>
        {/* <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  PO Intransit
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "vendorCode")}>
                  Vendor
                  {this.props.order === "desc" &&
                  this.props.sortField === "vendorCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "vendorName")}>
                  VendorName
                  {this.props.order === "desc" &&
                  this.props.sortField === "vendorName" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "inTransitDate")}
                >
                  InTransitDate
                  {this.props.order === "desc" &&
                  this.props.sortField === "inTransitDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "inTransitStatus")
                  }
                >
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "inTransitStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "shipmentTermsCode")
                  }
                >
                  ShipmentTerm
                  {this.props.order === "desc" &&
                  this.props.sortField === "shipmentTermsCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "containerNumber")
                  }
                >
                  ContainerNumber
                  {this.props.order === "desc" &&
                  this.props.sortField === "containerNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "containerDetail")
                  }
                >
                  ContainerDetail
                  {this.props.order === "desc" &&
                  this.props.sortField === "containerDetail" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {purchaseOrderInTransitListData != null ? (
              <tbody>
                {purchaseOrderInTransitListData.map((ln, index) => (
                  <tr key={index}>
                    <td className="hyperLinkText">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.editPurchaseOrderInTransit(e, ln.code)
                        }
                      >
                        {ln.code}
                      </Button>
                    </td>
                    <td>{ln.vendorCode}</td>
                    <td>{ln.vendorName}</td>
                    <td>{ModuleUtils.getDateFormat_v1(ln.inTransitDate)}</td>
                    <td>
                      {ModuleUtils.getPurchaseOrderInTransitStatusCaption(
                        ln.inTransitStatus,
                      )}
                    </td>
                    <td>{ln.shipmentTermsCode}</td>
                    <td>{ln.containerNumber}</td>
                    <td>{ln.containerDetail}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {purchaseOrderInTransitListData.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div> */}
      </div>
    );
  }
}
class PurchaseOrderInTransitForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.lineCancelReasonDialogRef = React.createRef();
    this.state = {
      //
    };
    this.purchaseOrderRef = React.createRef();
    this.fobCityRef = React.createRef();
    this.warehouseRef = React.createRef();
    this.paymentTermRef = React.createRef();
    this.shipmentTermRef = React.createRef();
    this.shipViaRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
  }
  componentDidUpdate() {
    // this.setInputFocus();
  }
  setInputFocus() {
    if (this.props.isFocus == true) {
      this.purchaseOrderRef.current.focus();
    }
  }
  initLookupHandlers = () => {
    let paymentTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.paymentTerms,
      "Payment Term",
    );
    this.setState({ paymentTermLookupHandler: paymentTermLookupHandler });
    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.props.wareHouses,
      "Warehouse",
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
    let shipmentTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipmentTerms,
      "ShipmentTerms",
    );
    this.setState({ shipmentTermLookupHandler: shipmentTermLookupHandler });
    let fobCityLookupHandler = new GenericAttributeLookupHandler(
      this.props.fOBCities,
      "FobCity",
    );
    this.setState({ fobCityLookupHandler: fobCityLookupHandler });
    let shipViaLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipVias,
      "ShipVia",
    );
    this.setState({ shipViaLookupHandler: shipViaLookupHandler });
    let purchaseOrderLookupHandler = new PurchaseOrderLookupHandler(
      this.companyCode,
      "Purchase Order",
      "",
      LogicConstants.PURCHASE_ORDER_APPROVE_STATUS,
    );
    this.setState({ purchaseOrderLookupHandler: purchaseOrderLookupHandler });
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  cancelPurchaseInTransitLine = (inTransitDeleteLineData) => {
    this.props.cancelPurchaseInTransitLine(inTransitDeleteLineData);
  };
  onLineChange = (e) => {
    this.props.onLineChange(e);
  };
  addOrUpdatePurchaseOrderInTransitLine = (e) => {
    if (e.detail == 1) {
      this.props.addOrUpdatePurchaseOrderInTransitLine(e);
      // this.closeLinePopup();
      this.props.closeAlertModalCallBack(false);
    }
  };
  showLinePopup = () => {
    this.props.showLinePopup();
  };
  closeLinePopup = () => {
    this.props.closeLinePopup();
  };
  editPurchaseOrderInTransitLine = (e, val, rowData) => {
    if (e.detail == 1) {
      this.showLinePopup();
      this.props.editPurchaseOrderInTransitLine(val, rowData);
    }
  };
  deleteInTransitLine = (e, rowData) => {
    if (e.detail == 1) this.cancelPurchaseInTransitLine(rowData);
  };
  editPurchaseOrderInTransitRollLine = (val, rowData) => {
    this.props.editPurchaseOrderInTransitRollLine(val, rowData);
  };
  onPurchaseOrderInTransitLineChange = (e) => {
    this.props.onPurchaseOrderInTransitLineChange(e);
  };
  onPurchaseOrderInTransitRollLineChange = (e) => {
    this.props.onPurchaseOrderInTransitRollLineChange(e);
  };
  addOrUpdatePurchaseOrderInTransitRollLine = (e) => {
    this.props.addOrUpdatePurchaseOrderInTransitRollLine(e);
  };
  addNewRollLine = (e) => {
    this.props.addNewRollLine(e);
  };
  getPurchaseOrderLinesDatasFromExcel = (e) => {
    this.props.getPurchaseOrderLinesDatasFromExcel(e);
  };
  uploadExcelFile = (e) => {
    this.props.uploadExcelFile(e);
  };
  lnkPOModule = (e) => {
    if (e.detail == 1) this.props.lnkPOModule();
  };
  purchaseOrderOnChange = (e) => {
    this.props.purchaseOrderOnChange(e);
  };
  displayAutoCompletePurchaseOrderList = (showAutoCompleteList) => {
    this.props.displayAutoCompletePurchaseOrderList(showAutoCompleteList);
  };
  purchaseOrderEnterKeyEventHandler = (e) => {
    this.props.purchaseOrderEnterKeyEventHandler(e);
  };
  locationOnChange = (e) => {
    this.props.locationOnChange(e);
  };
  locationEnterKeyEventHandler = (e) => {
    this.props.locationEnterKeyEventHandler(e);
  };
  displayLocationAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayLocationAutoCompleteList(showAutoCompleteList);
  };
  fobCityOnChange = (e) => {
    this.props.fobCityOnChange(e);
  };
  fobCityEnterKeyEventHandler = (e) => {
    this.props.fobCityEnterKeyEventHandler(e);
  };
  displayFobCityAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayFobCityAutoCompleteList(showAutoCompleteList);
  };
  shipmentTermOnChange = (e) => {
    this.props.shipmentTermOnChange(e);
  };
  shipmentTermEnterKeyEventHandler = (e) => {
    this.props.shipmentTermEnterKeyEventHandler(e);
  };
  displayShipmentTermAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayShipmentTermAutoCompleteList(showAutoCompleteList);
  };
  shipViaOnChange = (e) => {
    this.props.shipViaOnChange(e);
  };
  shipViaEnterKeyEventHandler = (e) => {
    this.props.shipViaEnterKeyEventHandler(e);
  };
  displayShipViaAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayShipViaAutoCompleteList(showAutoCompleteList);
  };
  closeModalCallBack = (isOpen) => {
    this.props.closeModalCallBack(isOpen);
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.props.closeAlertModalCallBack(isShowPopup);
  };
  render() {
    let purchaseOrderInTransitData = this.props.purchaseOrderInTransitData;
    let purchaseOrderInTransitLineData =
      this.props.purchaseOrderInTransitLineData;
    let purchaseOrderInTransitRollLineData =
      this.props.purchaseOrderInTransitRollLineData;
    let vendor_List = this.props.vendor_List;
    let disabledFormFields = this.props.disabledFormFields;
    let lines = purchaseOrderInTransitData.lines;
    if (!lines) {
      lines = new Array();
    }
    let isDisabledFields = this.props.isDisabledFields;
    const textAreaStyle = {
      maxHeight: "9em",
      width: "45em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
    };
    let isShowButtons = this.props.isShowButtons;
    let isModify = false;
    isModify = this.props.isModifyPosible();
    let disableUpdatableFields = false;
    if (disabledFormFields) {
      if (isModify) {
        disableUpdatableFields = false;
        isShowButtons = true;
      } else {
        disableUpdatableFields = true;
        isShowButtons = false;
      }
    }
    if (this.props.isViewMode) {
      disableUpdatableFields = true;
    }
    let is3PL = this.props.is3PL;
    let isTexco = this.props.isTexco;
    return (
      <div className="header_div">
        <div>
          <MultiViewPopup
            isModulePopup={true}
            id="modulePopup"
            isShowPopup={this.props.isShowPurchaseOrderModule}
            closeModalCallBack={this.closeModalCallBack}
            module={this.props.moduleForPopup}
          ></MultiViewPopup>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Intransit Date</FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent_adv
                name="inTransitDate"
                value={purchaseOrderInTransitData.inTransitDate}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col className="so-align-items-left" sm="1">
              <FormLabel
                className="hyperlinklabel"
                onClick={(e) => this.lnkPOModule(e)}
              >
                PO#
              </FormLabel>
              <Col>
                <ShortCutMenuPopup
                  value={purchaseOrderInTransitData.purchaseOrderNumber}
                  menuItems={
                    <ul>
                      <li
                        className="shortcut-menu-item"
                        onClick={(e) => this.lnkPOModule(e)}
                      >
                        {" "}
                        PurchaseOrder Info{" "}
                      </li>
                    </ul>
                  }
                />
              </Col>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.purchaseOrderOnChange}
                ref={this.purchaseOrderRef}
                // readOnly={disabledFormFields}
                disabled={isDisabledFields}
                name="purchaseOrderNumber"
                placeholder="purchaseOrderNumber"
                value={purchaseOrderInTransitData.purchaseOrderNumber}
                lookupRequired={this.props.isShowButtons}
                lookupHandler={this.state.purchaseOrderLookupHandler}
                enterKeyEventHandler={this.purchaseOrderEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.purchaseOrderPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompletePurchaseOrderList
                }
                showAutoCompleteList={
                  this.props.isShowAutoCompletePurchaseOrderList
                }
                isMandatory={true}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>Location</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.locationOnChange}
                ref={this.warehouseRef}
                placeholder="LocationCode"
                name="locationCode"
                value={purchaseOrderInTransitData.locationCode}
                lookupRequired={isShowButtons}
                lookupHandler={this.state.warehouseLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.locationEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.locationPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayLocationAutoCompleteList}
                showAutoCompleteList={this.props.isShowAutoCompleteLocationList}
                // readOnly={disabledFormFields}
                disabled={isDisabledFields}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Vendor</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="vendorCode"
                type="text"
                placeholder="Enter vendorCode"
                value={purchaseOrderInTransitData.vendorCode}
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Factory#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="factoryCode"
                type="text"
                placeholder="Enter factoryCode"
                value={purchaseOrderInTransitData.factoryCode}
                onChange={this.onChange}
                // readOnly={disableUpdatableFields}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
              />
            </Col>
            <Col sm="1">
              <FormLabel>PackingSlip#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="packingSlipNumber"
                type="text"
                placeholder="Enter packingSlipNumber"
                value={purchaseOrderInTransitData.packingSlipNumber}
                onChange={this.onChange}
                // readOnly={disableUpdatableFields}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
              />
            </Col>
            <Col sm="1">
              <FormLabel>ShipmentTerm#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.shipmentTermOnChange}
                ref={this.shipmentTermRef}
                placeholder="shipmentTermsCode"
                name="shipmentTermsCode"
                value={purchaseOrderInTransitData.shipmentTermsCode}
                lookupRequired={isShowButtons}
                lookupHandler={this.state.shipmentTermLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.shipmentTermEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.shipmentTermPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayShipmentTermAutoCompleteList
                }
                showAutoCompleteList={
                  this.props.isShowAutoCompleteShipmentTermList
                }
                // readOnly={disableUpdatableFields}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
              />
            </Col>
            <Col sm="1">
              <FormLabel>ShipVia#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.shipViaOnChange}
                ref={this.shipViaRef}
                placeholder="shipViaCode"
                name="shipViaCode"
                value={purchaseOrderInTransitData.shipViaCode}
                lookupRequired={isShowButtons}
                lookupHandler={this.state.shipViaLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.shipViaEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.shipViaPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayShipViaAutoCompleteList}
                showAutoCompleteList={this.props.isShowAutoCompleteShipViaList}
                // readOnly={disableUpdatableFields}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>FobCity#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.fobCityOnChange}
                ref={this.fobCityRef}
                placeholder="fOBCity"
                name="fOBCity"
                value={purchaseOrderInTransitData.fOBCity}
                lookupRequired={isShowButtons}
                lookupHandler={this.state.fobCityLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.fobCityEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.FobCityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayFobCityAutoCompleteList}
                showAutoCompleteList={this.props.isShowAutoCompleteFobCityList}
                // readOnly={disableUpdatableFields}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
              />
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>InTransit Date</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <DatePickerComponent_adv
                name="createdDate"
                value={purchaseOrderInTransitData.createdDate}
                onChange={this.onChange}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Eta Date</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <DatePickerComponent_adv
                name="etaDate"
                value={purchaseOrderInTransitData.etaDate}
                onChange={this.onChange}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
              />
            </Col>

            {isTexco && (
              <Col sm="1">
                <FormLabel>Etd Date</FormLabel>{" "}
              </Col>
            )}
            {isTexco && (
              <Col sm="2">
                <DatePickerComponent_adv
                  name="etdDate"
                  value={purchaseOrderInTransitData.etdDate}
                  onChange={this.onChange}
                  disabled={disableUpdatableFields}
                  isModifyView={isModify}
                />
              </Col>
            )}
            {/* <Col sm="1">
              <FormLabel>ManufacturerLot</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="manufacturerBatchNumber"
                type="text"
                placeholder="Enter billOfLading"
                value={purchaseOrderInTransitData.manufacturerBatchNumber}
                onChange={this.onChange}
                disabled={disabledFormFields}
              />
            </Col> */}
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>BillOfLading#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="billOfLading"
                type="text"
                placeholder="Enter billOfLading"
                value={purchaseOrderInTransitData.billOfLading}
                onChange={this.onChange}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
              />
            </Col>
            {is3PL && (
              <Col sm="1">
                <FormLabel>Container#</FormLabel>{" "}
              </Col>
            )}
            {is3PL && (
              <Col sm="2">
                <InputTextbox
                  name="containerNumber"
                  type="text"
                  value={purchaseOrderInTransitData.containerNumber}
                  onChange={this.onChange}
                  // readOnly={disableUpdatableFields}
                  // disabled={isDisabledFields}
                  disabled={disabledFormFields}
                />
              </Col>
            )}
            {is3PL && (
              <Col sm="1">
                <FormLabel>CustomerRef#</FormLabel>{" "}
              </Col>
            )}
            {is3PL && (
              <Col sm="2">
                <InputTextbox
                  name="customerReferenceNumber"
                  type="text"
                  value={purchaseOrderInTransitData.customerReferenceNumber}
                  onChange={this.onChange}
                  // readOnly={disableUpdatableFields}
                  // disabled={isDisabledFields}
                  disabled={disabledFormFields}
                />
              </Col>
            )}
            {isTexco && (
              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>VendorInvoice#</FormLabel>{" "}
              </Col>
            )}
            {isTexco && (
              <Col sm="2">
                <InputTextbox
                  name="vendorInvoiceNumber"
                  value={purchaseOrderInTransitData.vendorInvoiceNumber}
                  onChange={this.onChange}
                  disabled={disableUpdatableFields}
                />
              </Col>
            )}
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Comments</FormLabel>{" "}
            </Col>
            <Col sm="5">
              <textarea
                // style={textAreaStyle}
                className="form-control"
                name="comments"
                type="text"
                placeholder="Enter comments"
                onChange={this.onChange}
                value={purchaseOrderInTransitData.comments}
                // readOnly={disableUpdatableFields}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Container Details</FormLabel>{" "}
            </Col>
            <Col sm="5">
              <textarea
                // style={textAreaStyle}
                className="form-control"
                name="containerDetail"
                type="text"
                placeholder="Enter containerDetail"
                onChange={this.onChange}
                value={purchaseOrderInTransitData.containerDetail}
                // readOnly={disableUpdatableFields}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
              />
            </Col>
          </Row>
        </div>
        <div>
          <MultiViewPopup
            isModulePopup={false}
            isShowPopup={this.props.isShowPopup}
            closeOnEsc={false}
            popupLvlClass={"popupSizeLevel1"}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"LINE DETAIL"}
            closeOnDocumentClick={false}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.props.alertMessage}
                alertErrorType={this.props.alertType}
                isShowAlert={this.props.isShowPopupAlertlvl1}
                hideAlertCallBack={this.props.hideAlertCallBacklvl1}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                {this.props.isShowButtons && (
                  <Button
                    className="header_buttons"
                    size="sm"
                    onClick={(e) =>
                      this.addOrUpdatePurchaseOrderInTransitLine(e)
                    }
                  >
                    Add/Update
                  </Button>
                )}
              </div>
            }
            content={
              <div>
                <PurchaeOrderReceiptLinePopUpForm
                  isViewMode={this.props.isViewMode}
                  is3PL={this.props.is3PL}
                  toRollLineStatus={this.props.toRollLineStatus}
                  isShowButtons={this.props.isShowButtons}
                  disabledFormFields={this.props.disabledFormFields}
                  fabricStyle_List={this.props.fabricStyle_List}
                  purchaseOrderInTransitData={purchaseOrderInTransitData}
                  purchaseOrderInTransitLineData={
                    purchaseOrderInTransitLineData
                  }
                  purchaseOrderInTransitRollLineData={
                    purchaseOrderInTransitRollLineData
                  }
                  addOrUpdatePurchaseOrderInTransitRollLine={
                    this.addOrUpdatePurchaseOrderInTransitRollLine
                  }
                  onLineChange={this.onPurchaseOrderInTransitLineChange}
                  onRollLineChange={this.onPurchaseOrderInTransitRollLineChange}
                  editPurchaseOrderInTransitRollLine={
                    this.editPurchaseOrderInTransitRollLine
                  }
                  addNewRollLine={this.addNewRollLine}
                  getPurchaseOrderLinesDatasFromExcel={
                    this.getPurchaseOrderLinesDatasFromExcel
                  }
                  uploadExcelFile={this.uploadExcelFile}
                  cancelPurchaseInTransitRollLine={
                    this.props.cancelPurchaseInTransitRollLine
                  }
                  poInTransitRollLinesList={this.props.poInTransitRollLinesList}
                  alertMessage={this.props.alertMessage}
                  alertType={this.props.alertType}
                  isShowPopupAlertlvl5={this.props.isShowPopupAlertlvl5}
                  hideAlertCallBacklvl5={this.props.hideAlertCallBacklvl5}
                  clearRollLineDetails={this.props.clearRollLineDetails}
                  isShowRollLinePopup={this.props.isShowRollLinePopup}
                  showRollLinePopup={this.props.showRollLinePopup}
                  closeRollLinePopup={this.props.closeRollLinePopup}
                  closeLvl5ModalCallBack={this.props.closeLvl5ModalCallBack}
                  onRollLineCancelReasonContinue={
                    this.props.onRollLineCancelReasonContinue
                  }
                  onReasonChange={this.props.onReasonChange}
                  reasonData={this.props.reasonData}
                  cancelReason={this.props.cancelReason}
                  rollLineCancelReasonDialogRef={
                    this.props.rollLineCancelReasonDialogRef
                  }
                />
              </div>
            }
          />
        </div>
        <div className="div_Custom_4">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th>Line#</th>
                <th>{is3PL ? "Item#" : "FabricStyle#"}</th>
                <th>{is3PL ? "ItemName" : "FabricStyleName"}</th>
                <th>Color#</th>
                <th>UOM#</th>
                <th>OrdQty</th>
                <th>InTransitToDT</th>
                <th>InTransitQty</th>
                <th>ReceivedQty</th>
                <th>Status</th>
                {/* <th></th> */}
              </tr>
            </thead>
            {lines != null ? (
              <tbody>
                {lines.map((ln, index) => (
                  <tr key={index}>
                    <td className="hyperLinkText">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.editPurchaseOrderInTransitLine(
                            e,
                            ln.lineNumber,
                            ln,
                          )
                        }
                      >
                        {ln.lineNumber}
                      </Button>
                    </td>
                    <td>{ln.fabricStyleCode}</td>
                    <td>{ln.fabricStyleName}</td>
                    <td>{ln.colorCode}</td>
                    <td>{ln.uomCode}</td>
                    <td>{ln.purchaseOrderQuantity}</td>
                    <td>{ln.inTransitQuantityToDate}</td>
                    <td>{ln.inTransitQuantity}</td>
                    <td>{ln.receivedQuantity}</td>
                    {/* <td>{ln.lineStatus}</td> */}
                    <td>
                      {ModuleUtils.getPurchaseOrderInTransitLineStatusCaption(
                        ln.lineStatus,
                      )}
                    </td>
                    {/* <td>
                      {ln.lineStatus !=
                        LogicConstants.PURCHASE_ORDER_INTRANSIT_LINE_CANCEL_STATUS &&
                        ln.lineStatus !=
                          LogicConstants.PURCHASE_ORDER_INTRANSIT_LINE_RECEIVED_STATUS &&
                        this.props.isViewMode != true && (
                          <Button
                            size="sm"
                            onClick={(e) =>
                              this.deleteInTransitLine(e, ln.lineNumber, ln)
                            }
                          >
                            <DeleteIcon />
                          </Button>
                        )}
                    </td> */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {lines.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class PurchaeOrderReceiptLinePopUpForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }

  onLineChange = (e) => {
    this.props.onLineChange(e);
  };
  onRollLineUpdate = (e) => {
    if (e.detail == 1) this.props.addOrUpdatePurchaseOrderInTransitRollLine(e);
  };
  onRollLineChange = (e) => {
    this.props.onRollLineChange(e);
  };
  editPurchaseOrderInTransitRollLine = (e, val, rowData) => {
    if (e.detail == 1) {
      this.props.editPurchaseOrderInTransitRollLine(val, rowData);
      this.showRollLinePopup();
    }
  };
  deleteInTransitRollLine = (e, val, rowData) => {
    if (e.detail == 1) this.cancelPurchaseInTransitRollLine(rowData);
  };
  cancelPurchaseInTransitRollLine = (inTransitRollDeleteLineData) => {
    this.props.cancelPurchaseInTransitRollLine(inTransitRollDeleteLineData);
  };
  clearRollLineDetails = (e) => {
    if (e.detail == 1) this.props.clearRollLineDetails();
  };
  addNewRollLine = (e) => {
    if (e.detail == 1) {
      this.props.addNewRollLine(e);
      this.showRollLinePopup();
    }
  };
  showRollLinePopup = () => {
    this.props.showRollLinePopup();
  };
  closeRollLinePopup = () => {
    this.props.closeRollLinePopup();
  };
  closeLvl5ModalCallBack = (isShowPopup) => {
    this.props.closeLvl5ModalCallBack(isShowPopup);
  };
  onExcelClick = (e) => {
    if (e.detail <= 1) {
      const input = document.getElementById("file-input");
      if (input) {
        input.click();
      }
    }
  };
  uploadExcelFile = (e) => {
    this.props.uploadExcelFile(e);
  };
  toRollLineStatuss = (rollLineStatus, ln) => {
    let openQty = 0;
    let poInTransitRollLinesList = this.props.poInTransitRollLinesList;
    if (ln.adjustedTransitQuantity > 0) {
      openQty = ln.inTransitQuantity - ln.adjustedTransitQuantity;
      if (openQty == 0) {
        return (rollLineStatus = "Cancelled");
      }
    } else if (ln.receivedQuantity > 0) {
      return (rollLineStatus = "Received");
    } else {
      return (rollLineStatus = "Open");
    }
    return rollLineStatus;
  };
  render() {
    let purchaseOrderInTransitData = this.props.purchaseOrderInTransitData;
    let purchaseOrderInTransitLineData =
      this.props.purchaseOrderInTransitLineData;
    let purchaseOrderInTransitRollLineData =
      this.props.purchaseOrderInTransitRollLineData;
    let disabledFormFields = this.props.disabledFormFields;
    let vendor_List = this.props.vendor_List;
    let fabricStyle_List = this.props.fabricStyle_List;
    let inTransitRollLines = [];
    if (!isEmptyArray(this.props.poInTransitRollLinesList)) {
      inTransitRollLines = this.props.poInTransitRollLinesList;
    }
    let status = "";
    let is3PL = this.props.is3PL;
    if (!purchaseOrderInTransitRollLineData.isFetched) {
      disabledFormFields = false;
    }
    return (
      <div>
        <div className="header_div">
          {" "}
          <div>
            <Row>
              <Col sm="1">
                <FormLabel>CompanyCode#</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="companyCode"
                  type="text"
                  placeholder="Enter companyCode"
                  value={purchaseOrderInTransitLineData.companyCode}
                  onChange={this.onLineChange}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>POInTransit#</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="purchaseOrderInTransitNumber"
                  type="text"
                  value={
                    purchaseOrderInTransitLineData.purchaseOrderInTransitNumber
                  }
                  onChange={this.onLineChange}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Line#</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="lineNumber"
                  type="text"
                  placeholder="Enter LineNumber"
                  value={purchaseOrderInTransitLineData.lineNumber}
                  onChange={this.onLineChange}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Width</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="widthCode"
                  type="text"
                  placeholder="Enter Width"
                  value={purchaseOrderInTransitLineData.widthCode}
                  onChange={this.onLineChange}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>{is3PL ? "Item" : "FabricStyleCode"}</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="fabricStyleCode"
                  type="text"
                  placeholder="Enter fabricStyleCode"
                  value={purchaseOrderInTransitLineData.fabricStyleCode}
                  onChange={this.onLineChange}
                  disabled={true}
                />
              </Col>
              <Col sm="3">
                <InputTextbox
                  name="fabricStyleName"
                  type="text"
                  placeholder="Enter FabricStyleName"
                  value={purchaseOrderInTransitLineData.fabricStyleName}
                  onChange={this.onLineChange}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Color</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="colorCode"
                  type="text"
                  placeholder="Enter Color"
                  value={purchaseOrderInTransitLineData.colorCode}
                  onChange={this.onLineChange}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>UOM</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="uomCode"
                  type="text"
                  placeholder="Enter uomCode"
                  value={purchaseOrderInTransitLineData.uomCode}
                  onChange={this.onLineChange}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>Order Qty</FormLabel>
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  name={"purchaseOrderQuantity"}
                  onChange={this.onChange}
                  placeholder="Enter purchaseOrderQuantity"
                  value={purchaseOrderInTransitLineData.purchaseOrderQuantity}
                  className="qty_input text-right summary_input"
                  decimalScale={2}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Open InTransit Qty</FormLabel>
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  name={"openOrderQuantity"}
                  className="qty_input text-right summary_input"
                  onChange={this.onLineChange}
                  value={purchaseOrderInTransitLineData.openOrderQuantity}
                  decimalScale={2}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Total InTransit Qty</FormLabel>
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  name={"inTransitQuantity"}
                  onChange={this.onLineChange}
                  className="qty_input text-right summary_input"
                  value={purchaseOrderInTransitLineData.inTransitQuantity}
                  decimalScale={2}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>TotalRolls</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onChange}
                  className="qty_input text-right summary_input"
                  value={purchaseOrderInTransitLineData.totalRolls}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>IntransitToDT</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onChange}
                  className="qty_input text-right summary_input"
                  value={purchaseOrderInTransitLineData.inTransitQuantityToDate}
                  disabled={true}
                />
              </Col>
            </Row>
            <div>
              <Row>
                <Col sm="2">
                  <FormLabel className="label_head">
                    {" "}
                    Received Line Rolls
                  </FormLabel>
                </Col>
                <Col sm="2">
                  {this.props.isShowButtons && (
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm"
                      onClick={(e) => this.onExcelClick(e)}
                    >
                      Load From Excel
                    </Button>
                  )}
                  <input
                    type="file"
                    id="file-input"
                    style={{ display: "none" }}
                    onChange={this.uploadExcelFile}
                    accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
                  />
                </Col>
                <Col sm="3">
                  {this.props.isShowButtons && (
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm"
                      onClick={(e) => this.addNewRollLine(e)}
                    >
                      Add Roll Line
                    </Button>
                  )}
                </Col>
              </Row>
            </div>
            <div>
              <MultiViewPopup
                isModulePopup={false}
                isShowPopup={this.props.isShowRollLinePopup}
                closeOnEsc={false}
                closeAlertModalCallBack={this.closeLvl5ModalCallBack}
                title={"Roll LINE DETAIL"}
                closeOnDocumentClick={false}
                popupLvlClass={"popupSizeLevel5"}
                alertContainerBox={
                  <AlertToolBox
                    alertMsgList={this.props.alertMessage}
                    alertErrorType={this.props.alertType}
                    isShowAlert={this.props.isShowPopupAlertlvl5}
                    hideAlertCallBack={this.props.hideAlertCallBacklvl5}
                  />
                }
                headerButtonContainer={
                  <div className="floatLeft">
                    <Button
                      className="header_buttons"
                      size="sm"
                      onClick={(e) => this.onRollLineUpdate(e)}
                      disabled={disabledFormFields}
                    >
                      Add/Update
                    </Button>
                    <Button
                      className="header_buttons"
                      size="sm"
                      onClick={(e) => this.clearRollLineDetails(e)}
                      disabled={disabledFormFields}
                    >
                      clear
                    </Button>
                  </div>
                }
                content={
                  <div>
                    <PurchaeOrderReceiptRollLinePopUpForm
                      disabledFormFields={disabledFormFields}
                      fabricStyle_List={this.props.fabricStyle_List}
                      purchaseOrderInTransitData={purchaseOrderInTransitData}
                      purchaseOrderInTransitLineData={
                        purchaseOrderInTransitLineData
                      }
                      purchaseOrderInTransitRollLineData={
                        purchaseOrderInTransitRollLineData
                      }
                      onLineChange={this.onRollLineChange}
                      isModifyPosible={this.props.isModifyPosible}
                      is3PL={this.props.is3PL}
                    />
                  </div>
                }
              />
            </div>
            {/* <EditableDataGrid
            customStyles={styles}
            columnsList={this.columnDefinitions()}
            dataList={inTransitRollLines}
            isLoading={false}
          /> */}
            <div className="div_Custom_4">
              <Table id="fabrics_tables_default">
                <thead>
                  <tr>
                    <th>Line#</th>
                    <th>Roll#</th>
                    <th>{this.props.is3PL ? "Inventory#" : "RollSKU#"}</th>
                    <th>InTransitQty</th>
                    <th>VendorLot#</th>
                    <th>Box#</th>
                    <th>InvRcdQty#</th>
                    <th>InfoText</th>
                    <th>Bin Location#</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                {inTransitRollLines != null ? (
                  <tbody>
                    {inTransitRollLines.map((ln, index) => (
                      <tr key={index}>
                        <td className="hyperLinkText">
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.editPurchaseOrderInTransitRollLine(
                                e,
                                ln.inTransitRollLineNumber,
                                ln,
                              )
                            }
                          >
                            {ln.inTransitRollLineNumber}
                          </Button>
                        </td>
                        <td>{ln.rollNumber}</td>
                        <td>{ln.rollSkuNumber}</td>
                        <td>{ln.inTransitQuantity}</td>
                        <td>{ln.vendorLotNumber}</td>
                        <td>{ln.boxNumber}</td>
                        <td>{ln.inventoryReceivedQuantity}</td>
                        <td>{ln.infoText}</td>
                        <td>{ln.aisleInfoText}</td>
                        <td>{this.toRollLineStatuss(status, ln)}</td>
                        <td>
                          {this.toRollLineStatuss(status, ln) == "Open" &&
                            this.props.isViewMode != true && (
                              <Button
                                size="sm"
                                onClick={(e) =>
                                  this.deleteInTransitRollLine(
                                    e,
                                    ln.inTransitRollLineNumber,
                                    ln,
                                  )
                                }
                              >
                                <DeleteIcon />
                              </Button>
                            )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : null}
              </Table>
              {inTransitRollLines.length != 0 ? null : (
                <div className="no_Data">{"NO DATA"}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
class PurchaeOrderReceiptRollLinePopUpForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
    this.inTransitQtyRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  onLineChange = (e) => {
    this.props.onLineChange(e);
  };
  render() {
    let purchaseOrderInTransitRollLineData =
      this.props.purchaseOrderInTransitRollLineData;
    if (!purchaseOrderInTransitRollLineData) {
      purchaseOrderInTransitRollLineData =
        new PurchaseOrderInTransitRollLineBean();
    }
    let disabledFormFields = this.props.disabledFormFields;
    if (purchaseOrderInTransitRollLineData.isFetched == true) {
      disabledFormFields = true;
    } else {
      disabledFormFields = false;
    }

    return (
      <div>
        <div>
          <Row>
            <Col sm="2">
              <FormLabel>Line#</FormLabel>
            </Col>
            <Col sm="4">
              <InputTextbox
                name="lineNumber"
                type="text"
                placeholder="Enter LineNumber"
                value={
                  purchaseOrderInTransitRollLineData.inTransitRollLineNumber
                }
                disabled={true}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Intransit Qty</FormLabel>
            </Col>
            <Col sm="4">
              <NumberFormatInputbox
                ref={this.inTransitQtyRef}
                name={"inTransitQuantity"}
                onChange={this.onLineChange}
                placeholder="Enter inTransitQuantity"
                value={purchaseOrderInTransitRollLineData.inTransitQuantity}
                //className="qty_input text-right summary_input"
                decimalScale={2}
                disabled={disabledFormFields}
                isMandatory={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel>VENDOR LOT#</FormLabel>
            </Col>
            <Col sm="4">
              <InputTextbox
                name="vendorLotNumber"
                type="text"
                placeholder="Enter vendorLotNumber"
                value={purchaseOrderInTransitRollLineData.vendorLotNumber}
                disabled={disabledFormFields}
                onChange={this.onLineChange}
                isMandatory={true}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Box#</FormLabel>
            </Col>
            <Col sm="4">
              <InputTextbox
                name="boxNumber"
                type="text"
                placeholder="Enter boxNumber"
                value={purchaseOrderInTransitRollLineData.boxNumber}
                disabled={disabledFormFields}
                onChange={this.onLineChange}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel>Roll#</FormLabel>
            </Col>
            <Col sm="4">
              <InputTextbox
                name="rollNumber"
                type="text"
                placeholder="Enter rollNumber"
                value={purchaseOrderInTransitRollLineData.rollNumber}
                onChange={this.onLineChange}
                disabled={disabledFormFields}
                isMandatory={true}
              />
            </Col>
            <Col sm="2">
              <FormLabel>
                {this.props.is3PL ? "Inventory#" : "RollSKU#"}
              </FormLabel>
            </Col>
            <Col sm="4">
              <InputTextbox
                name="rollSkuNumber"
                type="text"
                // placeholder="Enter rollSkuNumber"
                placeholder={
                  this.props.is3PL ? "Enter Inventory#" : "Enter rollSKU#"
                }
                value={purchaseOrderInTransitRollLineData.rollSkuNumber}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel>InvUOM</FormLabel>
            </Col>
            <Col sm="4">
              <InputTextbox
                name="inventoryUomCode"
                type="text"
                placeholder="Enter inventoryUomCode"
                value={purchaseOrderInTransitRollLineData.inventoryUomCode}
                onChange={this.onLineChange}
                disabled={disabledFormFields}
              />
            </Col>
            <Col sm="2">
              <FormLabel>InvRcdQty</FormLabel>
            </Col>
            <Col sm="4">
              <NumberFormatInputbox
                name={"receivedQuantity"}
                onChange={this.onLineChange}
                value={purchaseOrderInTransitRollLineData.receivedQuantity}
                className="qty_input text-right summary_input"
                decimalScale={2}
                //   disabled={disabledFormFields}
                onBlur={this.onBlur}
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel>InfoText</FormLabel>
            </Col>
            <Col sm="4">
              <InputTextbox
                name="infoText"
                type="text"
                placeholder="Enter infoText"
                value={purchaseOrderInTransitRollLineData.infoText}
                onChange={this.onLineChange}
                disabled={disabledFormFields}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Asile InfoText</FormLabel>
            </Col>
            <Col sm="4">
              <InputTextbox
                name="aisleInfoText"
                type="text"
                placeholder="Enter aisleInfoText"
                value={purchaseOrderInTransitRollLineData.aisleInfoText}
                onChange={this.onLineChange}
                disabled={disabledFormFields}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
class PurchaseOrderInTransitHistoryDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  render() {
    let purchaseOrderInTransitData = this.props.purchaseOrderInTransitData;
    let statusTracks = purchaseOrderInTransitData.statusTracks;
    if (!statusTracks) {
      statusTracks = new Array();
    }
    let changeHistoryTracks = purchaseOrderInTransitData.changeHistoryTracks;
    if (!changeHistoryTracks) {
      changeHistoryTracks = new Array();
    }
    return (
      <div>
        <div className="header_div">
          <div className="div_Custom_3">
            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Previous Status</th>
                  <th>Done By</th>
                </tr>
              </thead>
              {statusTracks != null ? (
                <tbody>
                  {statusTracks.map((ln, index) => (
                    <tr key={index}>
                      <td>{ModuleUtils.getDateFormat_v1(ln.createdDate)}</td>
                      <td>
                        {ModuleUtils.getPurchaseOrderInTransitStatusCaption(
                          ln.currentStatus,
                        )}
                      </td>
                      <td>
                        {ModuleUtils.getPurchaseOrderInTransitStatusCaption(
                          ln.previousStatus,
                        )}
                      </td>
                      <td>{ln.createdBy}</td>
                    </tr>
                  ))}
                </tbody>
              ) : null}
            </Table>
            {statusTracks.length != 0 ? null : (
              <div className="no_Data">{"NO DATA"}</div>
            )}
          </div>
        </div>
        <div className="header_div">
          <div className="div_Custom_3">
            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th>description</th>
                  <th>UpdatedDate</th>
                  <th>UpdatedBY</th>
                </tr>
              </thead>
              {changeHistoryTracks != null ? (
                <tbody>
                  {changeHistoryTracks.map((ln, index) => (
                    <tr key={index}>
                      <td>{ln.description}</td>
                      <td>{ModuleUtils.getDateFormat_v1(ln.updatedDate)}</td>
                      <td>{ln.updatedBy}</td>
                    </tr>
                  ))}
                </tbody>
              ) : null}
            </Table>
            {changeHistoryTracks.length != 0 ? null : (
              <div className="no_Data">{"NO DATA"}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export function PurchaseOrderInTransitImageForm(props) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(props.imgUrl);
  const [images, setImages] = useState([...props.images]);
  const [img_Url, setImageUrl] = useState([...props.preview_Url]);
  const [tempIndex, setIndex] = useState(null);
  const [tempImage, setTempImages] = useState([]);
  const [tempImg_Url, setTempImageUrl] = useState([]);
  const [isImagePreview, setIsImagePreview] = useState(false);
  const [isImageMainPreview, setIsImageMainPreview] = useState(false);
  const isShowDocLabel = props.isShowDocLabel;
  const disabledImages = props.isServiceLineDisablesFields;
  const [imgDetails, setTempFile] = useState(null);
  const [hover, setHover] = useState(false);
  const [hoverData, setHoverData] = useState(
    new PurchaseOrderInTransitImageBean(),
  );
  const [aftUpload, setAftUpload] = useState(false);
  const purchaseOrderInTransitImages =
    props.purchaseOrderInTransitData.purchaseOrderInTransitImages;
  // const imageEntity = props.imageEntity;
  const [imageEntity, setImagesEntity] = useState(
    new PurchaseOrderInTransitImageBean(),
  );
  const handleChange = (e) => {
    let tempImages = e.target.files;
    if (!isEmptyArray(tempImages)) {
      setIsImageMainPreview(true);
    }
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    let img_list = [];
    let previewList = [];
    if (!isEmptyArray(images)) {
      img_list = [...images];
    }
    if (!isEmptyArray(img_Url)) {
      previewList = [...img_Url];
    }
    for (let index = 0; index < tempImages.length; index++) {
      // const element = tempImages[i];
      let imgUrl = "";
      if (tempImages[index].size <= max_size) {
        img_list.push(tempImages[index]);
        imgUrl = URL.createObjectURL(tempImages[index]);
        previewList.push(imgUrl);
      } else {
        props.showToast("image size is greater", 2);
      }
    }
    setImages(img_list);
    setImageUrl(previewList);
  };
  // useEffect(() => {
  //   setImageUrl(img_Url);
  // }, [img_Url]);
  // useEffect(() => {
  //   setImages(images);
  // }, [images]);
  useEffect(() => {
    setIsImageMainPreview(isImageMainPreview);
  }, [isImageMainPreview]);
  const handleImageEditChange = (e) => {
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    let images_temp = [];
    let url_temp = [];
    let imgUrl = "";
    if (e.target.files[0].size <= max_size) {
      images_temp = [...images];
      url_temp = [...img_Url];
      setIsImagePreview(true);
      setIsImageMainPreview(false);
      // })
      for (let i = 0; i < images_temp.length; i++) {
        if (i === tempIndex) {
          let file = e.target.files[0];
          setFile(file);
        }
      }
      for (let i = 0; i < url_temp.length; i++) {
        if (i === tempIndex) {
          imgUrl = URL.createObjectURL(e.target.files[0]);
          url_temp[i] = imgUrl; // Change the value at index 2
        }
      }
    } else {
      props.showToast("image size is greater", 2);
    }
    setPreviewUrl(imgUrl);
    setTempImages(images_temp);
    setTempImageUrl(url_temp);
  };
  useEffect(() => {
    setIsImagePreview(isImagePreview);
  }, [isImagePreview]);
  const handleSubmit = (e) => {
    e.preventDefault();
    props.setMultiImageUrl(img_Url);
    props.setMultiImgData(images);
    props.uploadMutiImage(images);
    props.showToast("Uploaded Sucessfully", 1);
    setIsImageMainPreview(false);
  };
  const handleEditSubmit = (e) => {
    e.preventDefault();
    let tempFile = file;
    for (let i = 0; i < tempImage.length; i++) {
      if (i === tempIndex) {
        tempFile.imageCode = tempImage[i].imageCode;
        tempImage[i] = tempFile;
      }
    }
    props.setMultiImageUrl(tempImg_Url);
    props.setMultiImgData(tempImage);
    props.uploadMutiImage(tempImage);
    setImageUrl(tempImg_Url);
    props.showToast("Uploaded Sucessfully", 1);
    setIndex(null);
    setIsImagePreview(false);
    setPreviewUrl("");
  };
  const deleteImage = (e) => {
    if (e.detail == 1) {
      setFile(null);
      setPreviewUrl("");
      // props.deleteImage();
      props.showToast("Image deleted sucessfully", 1);
      setIsImageMainPreview(false);
      setImages(props.images);
      setImageUrl(props.preview_Url);
    }
  };
  const imageview = (e, index, image) => {
    if (!isImageMainPreview) {
      const files = e.target.currentSrc;
      let imgDetails = null;
      const urls = files;
      setPreviewUrl(urls);
      setIndex(index);
      setIsImagePreview(false);
      // for (let i = 0; i < images.length; i++) {
      //   if (i === index) {
      //     imgDetails = images[i];
      //   }
      // }
      for (
        let i = 0;
        i <
        props.purchaseOrderInTransitData.purchaseOrderInTransitImages.length;
        i++
      ) {
        if (i === index) {
          imgDetails =
            props.purchaseOrderInTransitData.purchaseOrderInTransitImages[i];
        }
      }
      setTempFile(imgDetails);
      const updatedImageEntity = {
        ...imgDetails, // Spread the class instance to convert to plain object
        tags: imgDetails.tags !== "" ? imgDetails.tags : "",
        notesCommunication: imgDetails.notesCommunication || "",
      };
      setImagesEntity(updatedImageEntity);
      //
    }
  };
  const hoverview = (e, index) => {
    setAftUpload(true);
    if (!aftUpload) return; // Prevent hover logic if 'aftUpload' is false
    if (props.purchaseOrderInTransitData.isFetched) {
      const hoverDetails =
        props.purchaseOrderInTransitData.purchaseOrderInTransitImages[index]; // Get the hovered image by index
      if (hoverDetails) {
        setHoverData(hoverDetails); // Set hover data for the hovered image
      } else {
        //setHoverData(new PurchaseOrderInTransitImageBean()); // Fallback to default or empty data
      }
    }
    setHover(true); // Set hover state to true when mouse is over the image
  };
  const deleteUploadedImage = (e) => {
    if (e.detail === 1) {
      let url_temp = [];
      url_temp = [...img_Url];
      for (let i = 0; i < url_temp.length; i++) {
        if (i === tempIndex) {
          url_temp.splice(i, 1); // Change the value at index 2
        }
      }
      setImageUrl(url_temp);
      props.deleteMutipleImage(tempIndex);
      setPreviewUrl("");
      setTempImageUrl(url_temp);
      setIndex(null);
      setIsImagePreview(false);
    }
  };
  const onImageChange = (e) => {
    //let criteria = imageEntity;
    //imageEntity[e.target.name] = e.target.value;
    const updatedImageEntity = {
      ...imageEntity, // Spread the existing properties
      [e.target.name]: e.target.value, // Update the property based on input name
    };
    setImagesEntity(updatedImageEntity);
  };
  const addImageLines = (e) => {
    if (e.detail === 1) {
      props.addImageLines(imageEntity);
      props.showToast("Details Uploaded Sucessfully", 1);
    }
  };
  const clearImageLines = (e) => {
    if (e.detail === 1) {
      //props.clearImageLines(imageEntity)
      const updatedImageEntity = {
        ...imageEntity, // Spread the existing properties
        tags: "", // Reset tags
        notesCommunication: "", // Reset notesCommunication
      };
      setImagesEntity(updatedImageEntity);
      props.clearImageLines(updatedImageEntity);
    }
  };
  return (
    <div className="header_div  div_default">
      <div className="div_inline">
        <div className="div_30_no_overflow">
          <form onSubmit={handleSubmit}>
            <div className="d-flex justify-content-around ">
              <div>
                <label for="imgTag" className="d-flex justify-content-around">
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="imgTag"
                    multiple
                    accept="image/*"
                    onChange={handleChange}
                    disabled={disabledImages}
                  />
                </label>
              </div>
              {isImageMainPreview && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle-icon">
                    <button
                      id="fabric_Add_Button"
                      type="submit"
                      //  disabled={isShowDocLabel}
                    >
                      Upload
                    </button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteImage(e)}
                      //   disabled={isShowDocLabel}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.8rem" }}>
              {!isEmptyArray(img_Url) &&
                img_Url.map((image, index) => (
                  <div key={index} className="column">
                    <div className="effect">
                      <div className="effect-img">
                        <img
                          src={image}
                          alt={`upload-${index}`}
                          style={{
                            width: "100px",
                            height: "100px",
                            border: "1px solid black",
                            marginBottom: "5px", // Space between image and text
                            marginRight: "2px",
                            marginLeft: "2px",
                          }}
                          onClick={(e) => imageview(e, index)}
                          onMouseOver={(e) => hoverview(e, index)}
                          onMouseOut={() => setHover(false)} // Reset hover state on mouse out
                        />
                      </div>
                      {hover == true && (
                        <div className="effect-text">
                          <div class="inner">
                            <p
                            // style={{ fontSize: "12px", margin: 0 }}
                            >
                              {hoverData.imageName}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                    {/* Index Text Below Image */}
                  </div>
                ))}
            </div>
          </form>
          {/* </div> */}
        </div>
        <div className="div_60_no_overflow">
          {/* <div className="image-preview"> */}
          <form onSubmit={handleEditSubmit}>
            {
              !isEmpty(previewUrl) && (
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    paddingLeft: "200px",
                  }}
                >
                  <div className="image_grid">
                    {previewUrl != null && (
                      <div
                      // style={{ display: "flex", backgroundColor: "green" }}
                      >
                        <div
                          style={{
                            padding: "10px",
                            width: "100%",
                          }}
                        >
                          <img
                            src={previewUrl}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "200%",
                              float: "left",
                            }}
                          />
                          <label className="d-flex justify-content-around">
                            <div className="d-flex justify-content-around">
                              <span className="img_icon">
                                <CameraIcon />
                              </span>
                              <input
                                type="file"
                                className="img-input"
                                id="imgTag"
                                accept="image/*"
                                onChange={handleImageEditChange}
                                disabled={disabledImages}
                              />
                              <div className="d-flex justify-content-around align-middle">
                                <div className="align-middle">
                                  {isImagePreview && (
                                    <button
                                      id="fabric_Add_Button"
                                      type="submit"
                                      disabled={disabledImages}
                                    >
                                      Upload
                                    </button>
                                  )}
                                </div>
                                <div className="align-middle">
                                  <Button
                                    id="fabric_Add_Button"
                                    onClick={(e) => deleteUploadedImage(e)}
                                    disabled={disabledImages}
                                  >
                                    <DeleteIcon />
                                  </Button>
                                </div>
                              </div>
                              {/* <button
                              type="button"
                              id="fabric_Add_Button"
                            >
                              Remove
                            </button> */}
                            </div>
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      padding: "20px",
                    }}
                  >
                    <Row>
                      <Col sm="2">
                        <FormLabel>Name</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          //  value={imageEntity.imageName}
                          value={imageEntity.imageName || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Created By</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          //value={imageEntity.createdBy}
                          value={imageEntity.createdBy || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>created Date</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          // value={imageEntity.createdDate}
                          value={imageEntity.createdDate || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Tags</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          // value={imageEntity.tags}
                          value={imageEntity.tags || ""}
                          name="tags"
                          // type="text"
                          onChange={onImageChange}
                          disabled={disabledImages}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Notes</FormLabel>
                      </Col>
                      <Col sm="9">
                        <textarea
                          style={{
                            maxHeight: "10px",
                            width: "100%",
                            minHeight: "5em",
                            resize: "none",
                            padding: "9px",
                            boxSizing: "border-box",
                            fontSize: "15px",
                          }}
                          // className="form-control"
                          name="notesCommunication"
                          //  type="text"
                          // placeholder="Notes"
                          onChange={onImageChange}
                          value={imageEntity.notesCommunication || ""}
                          // value={imageEntity.notesCommunication}
                          disabled={disabledImages}
                        />
                        {/* <InputTextbox
                                  value={imgDetails.notesCommunication}
                                // disabled={true}
                                /> */}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-center">
                        <Button
                          size="sm"
                          id="fabric_Add_Button"
                          className="header_buttons enterFocus"
                          onClick={(e) => addImageLines(e)}
                          disabled={disabledImages}
                        >
                          Add/Update
                        </Button>
                        <Button
                          id="fabric_Add_Button"
                          size="sm1"
                          onClick={(e) => clearImageLines(e)}
                          disabled={disabledImages}
                        >
                          Clear
                        </Button>
                      </Col>
                    </Row>
                    {/* <p>{`Tags        : ${imgDetails.tags}`}</p>
                              <p>{`Notes       : ${imgDetails.notesCommunication}`}</p> */}
                    {/* </Col> */}
                  </div>
                </div>
              )
              // ))
            }
          </form>
          {/* // </div> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}
export function MutilpleDocuments(props) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewDocs] = useState(props.preview_Docs);
  const [documents, setDocuments] = useState([...props.documents]);
  const [tempIndex, setIndex] = useState(null);
  const documentData =
    props.purchaseOrderInTransitData.purchaseOrderInTransitDocuments || [];
  const [isDocumentUpload, setIsDocumentUpload] = useState(false);

  const disabledImages = props.isServiceLineDisablesFields;
  // useEffect(() => {
  //   setColumns(props.columns);
  // }, [props.columns]);

  const docHandler = (e) => {
    e.preventDefault();
    let tempDocs = e.target.files;
    let doc_list = [];
    let previewList = [];
    if (!isEmptyArray(documents)) {
      doc_list = [...documents];
    }
    if (!isEmptyArray(previewUrl)) {
      previewList = [...previewUrl];
    }
    for (let index = 0; index < tempDocs.length; index++) {
      let docUrl = "";
      doc_list.push(tempDocs[index]);
      docUrl = URL.createObjectURL(tempDocs[index]);
      previewList.push(docUrl);
    }
    setDocuments(doc_list);
    setPreviewDocs(previewList);
    setIsDocumentUpload(true);
  };

  useEffect(() => {
    setDocuments(documents);
  }, [documents]);

  const handleDocumentSubmit = (e) => {
    e.preventDefault();
    props.uploadMutiDouments(documents);
    props.uploadMutiDoumentsUrl(previewUrl);
    props.showToast("Uploaded Sucessfully", 1);
    setIsDocumentUpload(false);
  };
  const deleteDocs = (e) => {
    if (e.detail == 1) {
      setFile(null);
      setPreviewDocs("");
      props.showToast("Image deleted sucessfully", 1);
      setDocuments(props.documents);
      setIsDocumentUpload(false);
    }
  };

   const documentColumns = () => {
      const columns = new Array();
      columns.push(
        new ColumnDefinition()
                .setDetails("Document", "documentOriginalName", true)
          .setStyleDetails("left", "", "", "wt-10", "wt-10")
          .setClickDetails(true, false, editDocument, null)
          .setDocument(true)
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Document Name", "documentName", true)
          .setStyleDetails("left", "", "", "wt-10", "wt-10"),
      );
      columns.push(
        new ColumnDefinition()
   .setDetails("", <DeleteIcon />, false)
          .setStyleDetails("left", "2", "", "wt-2", "wt-2")
          .setClickDetails(false, true, deleteDocuments, <DeleteIcon />)
      );
  
      return columns;
    };

  const deleteDocuments = (e, value, rowData,index) => {
    let documentDataList = documents;
    let fileUrl = previewUrl;
    documentDataList.map((list, index) => {
      if (list.documentName === rowData.documentName) {
        // list.deleted = true;
        // list.isDeleted = true;
        fileUrl.splice(index, 1);
      }
    });
    setPreviewDocs(fileUrl);
    props.uploadMutiDoumentsUrl(fileUrl);
    props.deleteMultiDocument(rowData);
    // setDocuments(documentDataList);
    // setPreviewDocs(fileUrl);
    // props.uploadMutiDouments(documentDataList);
    // props.uploadMutiDoumentsUrl(fileUrl);
  };
  const editDocument = (e, name, tempIndex,rowIndex) => {
    let docUrl = previewUrl;
    let tempUrl = "";
    if (!isEmptyArray(docUrl)) {
      for (let index = 0; index < docUrl.length; index++) {
        if (index === rowIndex) {
          tempUrl = docUrl[index];
        }
      }
      window.open(tempUrl);
    }
  };
  return (
    <div className="header_div  div_default">
      <div className="div_inline">
        {/* <div className="div_80_no_overflow"> */}
        <div className="div_60_no_overflow">
          <div className="div_Equal_no_overflow">
            <form onSubmit={handleDocumentSubmit}>
              <div className="d-flex justify-content-around ">
                <div>
                  <label for="imgTag" className="d-flex justify-content-around">
                    <div className="img_label">
                      Attach Documents
                      <span className="img_icon">
                        <UploadDocIcon />
                      </span>
                    </div>

                    <input
                      type="file"
                      className="img-input"
                      id="imgTag"
                      multiple
                      accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
                      onChange={docHandler}
                      disabled={disabledImages}
                    />
                  </label>
                </div>
                {isDocumentUpload && (
                  <div className="d-flex justify-content-around align-middle">
                    <div className="align-middle">
                      <button
                        id="fabric_Add_Button"
                        type="submit"
                        //  disabled={isShowDocLabel}
                      >
                        Upload
                      </button>
                    </div>
                    <div className="align-middle">
                      <Button
                        id="fabric_Add_Button"
                        onClick={(e) => deleteDocs(e)}
                        // disabled={isShowDocLabel}
                      >
                        <DeleteIcon />
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* <div className="div_Custom_3">
        <Table id="fabrics_tables_default">
          <thead>
            <tr>
              <th>Document</th>
              <th>Document Name</th>
              <th>Delete</th>
            </tr>
          </thead>
          {documentData != null ? (
            <tbody>
              {documentData.map(
                (ln, index) =>
                  ln.isDeleted != true && (
                    <tr key={index}>
                      <td className="hyperLinkText">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            editDocument(e, ln.documentName, index)
                          }
                        >
                          {ln.documentOriginalName}
                        </Button>
                      </td>
                      <td>{ln.documentName}</td>
                      <td className="text-right">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            deleteDocuments(e, ln.documentCode, ln)
                          }
                          disabled={disabledImages}
                        >
                          {<DeleteIcon />}
                        </Button>
                      </td>
                    </tr>
                  ),
              )}
            </tbody>
          ) : null}
        </Table>
      </div> */}
      <div className="mt-3">
        <CustomTable
          data={documentData}
          columns={documentColumns()}
         // label={"Inquiry Data List"}
        />
      </div>
    </div>
  );
}

function PurchaseOrderInTransitModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div id="app_container"></div>
      <PurchaseOrderInTransitList {...props} name="" /> <br />
    </div>
  );
}

export default PurchaseOrderInTransitModule;
